import { renderTaskpaneShell } from "./taskpane-shell";

declare const Office: any;
declare const PowerPoint: any;
declare const signalR: any;
declare const JSZip: any;

renderTaskpaneShell();

type Nullable<T> = T | null | undefined;

interface HubConnection {
  on(methodName: string, callback: (...args: any[]) => void): void;
  start(): Promise<void>;
  stop(): Promise<void>;
  invoke<T = any>(methodName: string, ...args: any[]): Promise<T>;
}

interface SharedSpeaker {
  id?: string;
  Id?: string;
  name?: string;
  Name?: string;
  initials?: string;
  Initials?: string;
  colorHex?: string;
  ColorHex?: string;
  avatarDataUrl?: string;
  AvatarDataUrl?: string;
}

interface SharedSpeakerLink extends SharedSpeaker {
  code?: string;
  Code?: string;
  webUrl?: string;
  WebUrl?: string;
  isConnected?: boolean;
  IsConnected?: boolean;
}

interface PresentationStatus {
  timerState?: string;
  currentSlideIndexInPresentation?: number;
  currentSlideId?: number;
  powerPointFileName?: string;
  presentationName?: string;
  isPptSlideShowActive?: boolean;
  activeControlSpeakerId?: string;
  hostSpeakerId?: string;
}

interface AccessInfo {
  sessionCode?: string;
  isTrustedSpeaker?: boolean;
  isMainPresenter?: boolean;
  isWaiting?: boolean;
  speaker?: SharedSpeaker;
}

interface RemoteStartResult {
  started?: boolean;
  sessionCode?: string;
}

interface ShareSessionCreated {
  code?: string;
  participantCode?: string;
  participantWebUrl?: string;
  speakerLinks?: SharedSpeakerLink[];
  mainPresenterCode?: string;
  mainPresenterWebUrl?: string;
}

interface SlideTarget {
  slideId: number;
  slideIndex: number;
}

interface SlideNavigationMessage {
  direction?: number;
  speakerName?: string;
}

interface SlideSyncMessage {
  slideId?: number;
  slideIndex?: number;
  speakerName?: string;
  hostSpeakerId?: string;
}

interface EmbeddedRemoteStartInfo {
  sessionCode: string;
  participantCode: string;
  mainPresenterCode: string;
}

type PaneView = "share" | "connect" | "edit";
type EditTab = "settings" | "sections" | "breaks" | "speakers";

const timerNamespaceUri = "https://timerinator.app/powerpoint-timer/2026";
const shareSpeakerPreferencePrefix = "timerinator.powerpoint.shareSpeaker";

const elements = {
  hostView: document.getElementById("hostView") as HTMLElement,
  connectView: document.getElementById("connectView") as HTMLElement,
  editView: document.getElementById("editView") as HTMLElement,
  startSharingButton: document.getElementById("startSharingButton") as HTMLButtonElement,
  shareStatus: document.getElementById("shareStatus") as HTMLElement,
  shareSpeakerShimmer: document.getElementById("shareSpeakerShimmer") as HTMLElement,
  shareSpeakerPicker: document.getElementById("shareSpeakerPicker") as HTMLElement,
  shareSpeakerPickerAvatar: document.getElementById("shareSpeakerPickerAvatar") as HTMLElement,
  shareSpeakerPickerInput: document.getElementById("shareSpeakerPickerInput") as HTMLInputElement,
  shareSpeakerPickerButton: document.getElementById("shareSpeakerPickerButton") as HTMLButtonElement,
  shareSpeakerList: document.getElementById("shareSpeakerList") as HTMLElement,
  shareSpeakersEmptyState: document.getElementById("shareSpeakersEmptyState") as HTMLElement,
  shareResultPanel: document.getElementById("shareResultPanel") as HTMLElement,
  participantCodeOutput: document.getElementById("participantCodeOutput") as HTMLInputElement,
  copyParticipantCodeButton: document.getElementById("copyParticipantCodeButton") as HTMLButtonElement,
  participantLinkOutput: document.getElementById("participantLinkOutput") as HTMLInputElement,
  copyParticipantLinkButton: document.getElementById("copyParticipantLinkButton") as HTMLButtonElement,
  mainPresenterLinkOutput: document.getElementById("mainPresenterLinkOutput") as HTMLInputElement,
  copyMainPresenterLinkButton: document.getElementById("copyMainPresenterLinkButton") as HTMLButtonElement,
  coPresenterLinksStatus: document.getElementById("coPresenterLinksStatus") as HTMLElement,
  speakerLinksPanel: document.getElementById("speakerLinksPanel") as HTMLElement,
  shareCodeInput: document.getElementById("shareCodeInput") as HTMLInputElement,
  connectButton: document.getElementById("connectButton") as HTMLButtonElement,
  disconnectButton: document.getElementById("disconnectButton") as HTMLButtonElement,
  connectStatus: document.getElementById("connectStatus") as HTMLElement,
  timerSection: document.getElementById("timerSection") as HTMLElement,
  controlBadge: document.getElementById("controlBadge") as HTMLElement,
  presentationName: document.getElementById("presentationName") as HTMLElement,
  timerState: document.getElementById("timerState") as HTMLElement,
  slideStatus: document.getElementById("slideStatus") as HTMLElement,
  startRemoteButton: document.getElementById("startRemoteButton") as HTMLButtonElement,
  settingsTabButton: document.getElementById("settingsTabButton") as HTMLButtonElement,
  sectionsTabButton: document.getElementById("sectionsTabButton") as HTMLButtonElement,
  breaksTabButton: document.getElementById("breaksTabButton") as HTMLButtonElement,
  speakersTabButton: document.getElementById("speakersTabButton") as HTMLButtonElement,
  settingsPanel: document.getElementById("settingsPanel") as HTMLElement,
  sectionsPanel: document.getElementById("sectionsPanel") as HTMLElement,
  breaksPanel: document.getElementById("breaksPanel") as HTMLElement,
  speakersPanel: document.getElementById("speakersPanel") as HTMLElement,
  scheduledStartInput: document.getElementById("scheduledStartInput") as HTMLInputElement,
  delayedStartSlideInput: document.getElementById("delayedStartSlideInput") as HTMLInputElement,
  startOffsetInput: document.getElementById("startOffsetInput") as HTMLInputElement,
  totalAvailableInput: document.getElementById("totalAvailableInput") as HTMLInputElement,
  breakTotalOutput: document.getElementById("breakTotalOutput") as HTMLElement,
  slideTimeOutput: document.getElementById("slideTimeOutput") as HTMLElement,
  allocatedTimeOutput: document.getElementById("allocatedTimeOutput") as HTMLElement,
  remainingTimeOutput: document.getElementById("remainingTimeOutput") as HTMLElement,
  overAllocatedWarning: document.getElementById("overAllocatedWarning") as HTMLElement,
  sectionsList: document.getElementById("sectionsList") as HTMLElement,
  sectionsShimmer: document.getElementById("sectionsShimmer") as HTMLElement,
  sectionsEmptyState: document.getElementById("sectionsEmptyState") as HTMLElement,
  addBreakButton: document.getElementById("addBreakButton") as HTMLButtonElement,
  breaksList: document.getElementById("breaksList") as HTMLElement,
  breaksShimmer: document.getElementById("breaksShimmer") as HTMLElement,
  breaksEmptyState: document.getElementById("breaksEmptyState") as HTMLElement,
  addSpeakerButton: document.getElementById("addSpeakerButton") as HTMLButtonElement,
  speakersList: document.getElementById("speakersList") as HTMLElement,
  speakersShimmer: document.getElementById("speakersShimmer") as HTMLElement,
  speakersEmptyState: document.getElementById("speakersEmptyState") as HTMLElement,
  speakerPickerButton: document.getElementById("speakerPickerButton") as HTMLButtonElement,
  speakerPickerValue: document.getElementById("speakerPickerValue") as HTMLElement,
  speakerPickerList: document.getElementById("speakerPickerList") as HTMLElement,
  editStatus: document.getElementById("editStatus") as HTMLElement
};

enforceEditPivotOrder();

let connection: HubConnection | null = null;
let activeCode = "";
let activeHubOrigin = "";
let isTrustedSpeaker = false;
let isMainPresenter = false;
let isSessionWaiting = false;
let trustedSpeaker: SharedSpeaker | null = null;
let presentation: any = null;
let embeddedPresentation: any = null;
let timerStatus: PresentationStatus | null = null;
let currentDeckUrl = "";
let currentDeckFileName = "";
let lastSyncedTarget = "";
let pollHandle = 0;
let embeddedRemoteStartInfo: EmbeddedRemoteStartInfo | null = null;
let embeddedRemoteStartLoaded = false;
let embeddedMetadataLoaded = false;
let activeView: PaneView = "share";
let editSpeakers: SharedSpeaker[] = [];
let editSpeakerListOpen = false;
let editFocusedSpeakerIndex = -1;
let activeShareResult: ShareSessionCreated | null = null;
let activeEditTab: EditTab = "settings";
let editDraft: any = null;
let editDirty = false;
let editDirtyFields = new Set<string>();
let editSaveInProgress = false;
let editAutosaveTimer = 0;
let activeSectionEditIndex: number | null = null;
let activeBreakEditIndex: number | null = null;
let activeSpeakerEditIndex: number | null = null;
let powerPointPackageHydrated = false;
let powerPointPackageHydrationPromise: Promise<void> | null = null;
let sectionDetailsLoading = true;
let breakDetailsLoading = true;
let speakerDetailsLoading = true;
let shareSpeakers: SharedSpeaker[] = [];
let shareFilteredSpeakers: SharedSpeaker[] = [];
let selectedShareSpeakerId = "";
let shareSpeakerListOpen = false;
let shareFocusedSpeakerIndex = -1;
let shareSpeakerFilter = "";
let shareSpeakersLoading = true;

Office.onReady(() => {
  initialize();
});

async function initialize(): Promise<void> {
  applyOfficeTheme();
  registerOfficeThemeEvents();
  activeView = readInitialView();
  showView(activeView);
  elements.startSharingButton.addEventListener("click", () => {
    if (activeShareResult) {
      void stopSharingFromAddIn();
    } else {
      void shareCurrentPresentation();
    }
  });
  elements.shareSpeakerPickerButton.addEventListener("click", () => toggleShareSpeakerPicker());
  elements.shareSpeakerPickerInput.addEventListener("focus", () => {
    elements.shareSpeakerPickerInput.select();
    openShareSpeakerPicker();
  });
  elements.shareSpeakerPickerInput.addEventListener("input", () => {
    shareSpeakerFilter = elements.shareSpeakerPickerInput.value;
    openShareSpeakerPicker();
    renderShareSpeakers(true);
  });
  elements.shareSpeakerPickerInput.addEventListener("keydown", event => handleShareSpeakerPickerInputKeyDown(event));
  elements.shareSpeakerPickerButton.addEventListener("keydown", event => handleShareSpeakerPickerInputKeyDown(event));
  elements.shareSpeakerList.addEventListener("keydown", event => handleShareSpeakerListKeyDown(event));
  elements.copyParticipantCodeButton.addEventListener("click", () => copyOutputValue(elements.participantCodeOutput, "Participant code copied."));
  elements.copyParticipantLinkButton.addEventListener("click", () => copyOutputValue(elements.participantLinkOutput, "Participant link copied."));
  elements.copyMainPresenterLinkButton.addEventListener("click", () => copyOutputValue(elements.mainPresenterLinkOutput, "Main presenter link copied."));
  elements.connectButton.addEventListener("click", () => connectToSharedTimer());
  elements.disconnectButton.addEventListener("click", () => disconnect());
  elements.startRemoteButton.addEventListener("click", () => startRemoteSession());
  registerEditPaneEvents();
  elements.shareCodeInput.addEventListener("keydown", event => {
    if (event.key === "Enter") {
      event.preventDefault();
      connectToSharedTimer();
    }
  });
  registerOfficeSlideEvents();
  addDiagnostic("Add-in initialized.");
  if (activeView === "edit") {
    void updateEditView();
  }
  await Promise.all([loadDocumentIdentity(), loadEmbeddedRemoteStartInfo()]);
  markEmbeddedMetadataReady();
  if (!editDirty) {
    editDraft = null;
  }

  renderShareSpeakers();
  updateShareButtonState();
  void updateEditView();
  startPowerPointPackageHydration(activeView === "share" ? "share pane" : activeView === "edit" ? "edit pane" : "startup");
  if (activeView === "connect" && !readCodeFromQuery() && embeddedRemoteStartInfo?.mainPresenterCode) {
    elements.shareCodeInput.value = embeddedRemoteStartInfo.mainPresenterCode;
    elements.connectStatus.textContent = "Remote-start settings found in this presentation.";
  }
}

function applyOfficeTheme(theme = Office.context?.officeTheme): void {
  if (!theme) {
    return;
  }

  const root = document.documentElement;
  const bodyBackground = normalizeThemeColor(theme.bodyBackgroundColor);
  const bodyForeground = normalizeThemeColor(theme.bodyForegroundColor);
  const controlBackground = normalizeThemeColor(theme.controlBackgroundColor);
  const controlForeground = normalizeThemeColor(theme.controlForegroundColor);

  setThemeColor(root, "--bg", bodyBackground);
  setThemeColor(root, "--text", bodyForeground);
  setThemeColor(root, "--control", controlBackground);
  setThemeColor(root, "--focus", controlForeground);

  const baseBackground = bodyBackground || "#f3f2f1";
  const baseForeground = bodyForeground || "#323130";
  const controlBase = controlBackground || baseBackground;
  const controlText = controlForeground || baseForeground;

  root.style.setProperty("--muted", mixHex(baseForeground, baseBackground, 0.72));
  root.style.setProperty("--border", mixHex(baseForeground, baseBackground, 0.24));
  root.style.setProperty("--strong-border", mixHex(controlText, controlBase, 0.55));
  root.style.setProperty("--control-hover", mixHex(controlText, controlBase, 0.08));
  root.style.setProperty("--control-pressed", mixHex(controlText, controlBase, 0.16));
  root.style.setProperty("--disabled-bg", mixHex(baseForeground, baseBackground, 0.08));
  root.style.setProperty("--disabled-text", mixHex(baseForeground, baseBackground, 0.38));
}

function registerOfficeThemeEvents(): void {
  const eventType = Office.EventType?.OfficeThemeChanged;
  if (!eventType) {
    return;
  }

  const contextApi = Office.context as any;
  const possibleTargets = [
    contextApi,
    contextApi?.document,
    contextApi?.officeTheme
  ].filter(target => !!target?.addHandlerAsync);

  for (const target of possibleTargets) {
    try {
      target.addHandlerAsync(eventType, (event: any) => {
        applyOfficeTheme(event?.officeTheme || Office.context?.officeTheme);
      });
    } catch {
    }
  }
}

function setThemeColor(root: HTMLElement, name: string, value: string): void {
  if (value) {
    root.style.setProperty(name, value);
  }
}

function normalizeThemeColor(value: any): string {
  if (typeof value !== "string") {
    return "";
  }

  const color = value.trim();
  if (!color || !CSS.supports("color", color)) {
    return "";
  }

  return color;
}

function mixHex(foreground: string, background: string, amount: number): string {
  const foregroundRgb = parseColor(foreground);
  const backgroundRgb = parseColor(background);
  if (!foregroundRgb || !backgroundRgb) {
    return foreground || background || "";
  }

  return toHex({
    r: Math.round(backgroundRgb.r + (foregroundRgb.r - backgroundRgb.r) * amount),
    g: Math.round(backgroundRgb.g + (foregroundRgb.g - backgroundRgb.g) * amount),
    b: Math.round(backgroundRgb.b + (foregroundRgb.b - backgroundRgb.b) * amount)
  });
}

function parseColor(value: string): { r: number; g: number; b: number } | null {
  const hex = parseHexColor(value);
  if (hex) {
    return hex;
  }

  const rgb = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/i.exec(value);
  if (rgb) {
    return {
      r: Number.parseInt(rgb[1], 10),
      g: Number.parseInt(rgb[2], 10),
      b: Number.parseInt(rgb[3], 10)
    };
  }

  return null;
}

function parseHexColor(value: string): { r: number; g: number; b: number } | null {
  const shortHex = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(value);
  if (shortHex) {
    return {
      r: Number.parseInt(shortHex[1] + shortHex[1], 16),
      g: Number.parseInt(shortHex[2] + shortHex[2], 16),
      b: Number.parseInt(shortHex[3] + shortHex[3], 16)
    };
  }

  const match = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(value);
  if (!match) {
    return null;
  }

  return {
    r: Number.parseInt(match[1], 16),
    g: Number.parseInt(match[2], 16),
    b: Number.parseInt(match[3], 16)
  };
}

function toHex(color: { r: number; g: number; b: number }): string {
  const parts = [color.r, color.g, color.b].map(part => Math.max(0, Math.min(255, part)).toString(16).padStart(2, "0"));
  return `#${parts.join("")}`;
}

function readInitialView(): PaneView {
  const query = new URLSearchParams(window.location.search);
  const view = query.get("view")?.toLowerCase();
  if (view === "edit") {
    return "edit";
  }

  if (view === "connect") {
    return "connect";
  }

  return "share";
}

function showView(view: PaneView): void {
  activeView = view;
  elements.hostView.hidden = view !== "share";
  elements.connectView.hidden = view !== "connect";
  elements.editView.hidden = view !== "edit";
  document.title = getViewTitle(view);
  window.setTimeout(() => {
    if (view === "edit") {
      elements.settingsTabButton.focus();
      void updateEditView();
      startPowerPointPackageHydration("edit pane");
    } else if (view === "connect") {
      elements.shareCodeInput.focus();
    } else {
      elements.startSharingButton.focus();
      startPowerPointPackageHydration("share pane");
    }
  }, 0);
  addDiagnostic(`${getViewTitle(view)} view requested from ribbon.`);
}

function getViewTitle(view: PaneView): string {
  switch (view) {
    case "connect":
      return "Connect to shared timer";
    case "edit":
      return "Edit timer";
    default:
      return "Share presentation";
  }
}

function getServiceOrigin(): string {
  return window.location.origin;
}

async function updateEditView(): Promise<void> {
  if (activeView !== "edit") {
    return;
  }

  if (!editDraft) {
    editDraft = cloneJson(normalizeEditModel(getOrCreateEmbeddedPresentation()));
    editDirty = false;
    populateEditInputs();
  }

  renderEditPane();
  setEditStatus(editDirty ? "Saving changes..." : "");
}

function registerEditPaneEvents(): void {
  enforceEditPivotOrder();
  elements.settingsTabButton.addEventListener("click", () => selectEditTab("settings"));
  elements.sectionsTabButton.addEventListener("click", () => selectEditTab("sections"));
  elements.speakersTabButton.addEventListener("click", () => selectEditTab("speakers"));
  elements.breaksTabButton.addEventListener("click", () => selectEditTab("breaks"));

  const timingInputs: Array<[HTMLInputElement, string]> = [
    [elements.scheduledStartInput, "StartTime"],
    [elements.delayedStartSlideInput, "DelayedStartSlideIndex"],
    [elements.startOffsetInput, "StartOffsetMinutes"],
    [elements.totalAvailableInput, "TotalAvailableMinutes"]
  ];

  timingInputs.forEach(([input, fieldName]) => input.addEventListener("input", () => {
    commitEditInputs();
    markEditDirty(fieldName);
    renderTimingSummary();
  }));

  elements.addBreakButton.addEventListener("click", () => {
    const breaks = normalizeArray(ensureEditDraft().Breaks);
    breaks.push(createPresentationBreak());
    ensureEditDraft().Breaks = breaks;
    activeBreakEditIndex = breaks.length - 1;
    markEditDirty();
    renderEditPane();
    window.setTimeout(() => document.getElementById(`breakName${activeBreakEditIndex}`)?.focus(), 0);
  });
  elements.addSpeakerButton.addEventListener("click", () => {
    const speakers = normalizeArray(ensureEditDraft().Speakers);
    speakers.push(createPresentationSpeaker());
    ensureEditDraft().Speakers = speakers;
    activeSpeakerEditIndex = speakers.length - 1;
    markEditDirty();
    renderEditPane();
    window.setTimeout(() => document.getElementById(`speakerName${activeSpeakerEditIndex}`)?.focus(), 0);
  });

  elements.sectionsList.addEventListener("input", event => handleEditorInput("Sections", event));
  elements.sectionsList.addEventListener("change", event => handleEditorInput("Sections", event));
  elements.sectionsList.addEventListener("click", event => handleEditorCommand("Sections", event));
  elements.breaksList.addEventListener("input", event => handleEditorInput("Breaks", event));
  elements.breaksList.addEventListener("change", event => handleEditorInput("Breaks", event));
  elements.breaksList.addEventListener("click", event => handleEditorCommand("Breaks", event));
  elements.speakersList.addEventListener("input", event => handleEditorInput("Speakers", event));
  elements.speakersList.addEventListener("change", event => { void handleSpeakerListChange(event); });
  elements.speakersList.addEventListener("click", event => handleEditorCommand("Speakers", event));
}

function selectEditTab(tab: EditTab, render = true): void {
  enforceEditPivotOrder();
  activeEditTab = tab;
  const entries: Array<[EditTab, HTMLButtonElement, HTMLElement]> = [
    ["settings", elements.settingsTabButton, elements.settingsPanel],
    ["sections", elements.sectionsTabButton, elements.sectionsPanel],
    ["speakers", elements.speakersTabButton, elements.speakersPanel],
    ["breaks", elements.breaksTabButton, elements.breaksPanel]
  ];

  for (const [name, button, panel] of entries) {
    const selected = name === tab;
    button.classList.toggle("selected", selected);
    button.setAttribute("aria-pressed", selected ? "true" : "false");
    button.setAttribute("aria-selected", selected ? "true" : "false");
    if (selected) {
      button.closest("fluent-tabs")?.setAttribute("activeid", button.id);
    }
    panel.hidden = !selected;
  }

  if (render) {
    startPowerPointPackageHydration(`edit ${tab} tab`);
    renderActiveEditTab();
  }
}

function enforceEditPivotOrder(): void {
  const pivot = elements.settingsTabButton.closest("fluent-tabs");
  if (pivot && elements.speakersTabButton.nextElementSibling !== elements.breaksTabButton) {
    pivot.insertBefore(elements.speakersTabButton, elements.breaksTabButton);
  }

  const editView = elements.sectionsPanel.parentElement;
  if (editView && elements.speakersPanel.nextElementSibling !== elements.breaksPanel) {
    editView.insertBefore(elements.speakersPanel, elements.breaksPanel);
  }
}

function ensureEditDraft(): any {
  if (!editDraft) {
    editDraft = cloneJson(normalizeEditModel(getOrCreateEmbeddedPresentation()));
    populateEditInputs();
  }

  return editDraft;
}

function normalizeEditModel(model: any): any {
  const title = String(model?.Title || model?.title || model?.Name || model?.name || currentDeckFileName || "PowerPoint presentation");
  const sections = normalizeArray(model?.Sections || model?.sections).map(normalizeEditSection);
  const breaks = normalizeArray(model?.Breaks || model?.breaks).map(normalizeEditBreak);
  const slideSpeakers = model?.SlideSpeakers || model?.slideSpeakers || {};
  const speakers = addMissingSpeakersFromAssignments(
    normalizeArray(model?.Speakers || model?.speakers).map(normalizeEditSpeaker),
    slideSpeakers);
  const totalAvailableMinutes = toNonNegativeInteger(
    model?.TotalAvailableMinutes ?? model?.totalAvailableMinutes,
    sections.reduce((sum: number, section: any) => sum + Math.ceil(toNonNegativeInteger(section.DurationSeconds, 0) / 60), 0));

  return {
    ...model,
    Name: title,
    Title: title,
    PowerPointPath: currentDeckUrl || model?.PowerPointPath || model?.powerPointPath || "",
    TotalAvailableMinutes: totalAvailableMinutes,
    StartTime: normalizeTimeText(model?.StartTime ?? model?.startTime ?? model?.ScheduledStartTime ?? model?.scheduledStartTime),
    DelayedStartSlideIndex: Math.max(1, toNonNegativeInteger(model?.DelayedStartSlideIndex ?? model?.delayedStartSlideIndex, 1)),
    StartOffsetMinutes: toNonNegativeInteger(model?.StartOffsetMinutes ?? model?.startOffsetMinutes, 0),
    Sections: sections,
    Breaks: breaks,
    Speakers: speakers,
    SlideSpeakers: slideSpeakers,
    SlideCallouts: model?.SlideCallouts || model?.slideCallouts || {},
    SlideMaximumSeconds: model?.SlideMaximumSeconds || model?.slideMaximumSeconds || {},
    SlideMaximumSecondsBySlideId: model?.SlideMaximumSecondsBySlideId || model?.slideMaximumSecondsBySlideId || {},
    SlideAnimationStepCounts: model?.SlideAnimationStepCounts || model?.slideAnimationStepCounts || {}
  };
}

function addMissingSpeakersFromAssignments(speakers: any[], slideSpeakers: any): any[] {
  if (!slideSpeakers || typeof slideSpeakers !== "object") {
    return speakers;
  }

  const result = [...speakers];
  const refs = Object.values(slideSpeakers)
    .map(value => String(value || "").trim())
    .filter(value => !!value && !isHostSpeakerReference(value));

  for (const ref of refs) {
    const exists = result.some(speaker =>
      speakerKey(String(speaker.Id || "")) === speakerKey(ref) ||
      speakerKey(String(speaker.Name || "")) === speakerKey(ref) ||
      speakerKey(String(speaker.Initials || "")) === speakerKey(ref));
    if (exists) {
      continue;
    }

    result.push(normalizeEditSpeaker({
      Name: ref,
      Initials: looksLikeInitials(ref) ? ref : generateInitials(ref),
      ColorHex: pickSpeakerColor(result.length)
    }, result.length));
  }

  return result;
}

function looksLikeInitials(value: string): boolean {
  return /^[A-Z]{2,3}$/.test(value.trim());
}

function normalizeEditSection(section: any, index: number): any {
  const durationSeconds = toNonNegativeInteger(section?.DurationSeconds ?? section?.durationSeconds, 300);
  return {
    ...section,
    Name: String(section?.Name || section?.name || `Section ${index + 1}`),
    DurationSeconds: durationSeconds,
    ColorHex: normalizeSpeakerColor(String(section?.ColorHex || section?.colorHex || pickSectionColor(index))),
    Slides: Math.max(1, toNonNegativeInteger(section?.Slides ?? section?.slides, 1)),
    SectionType: normalizeSectionType(String(section?.SectionType || section?.sectionType || "Slides")),
    MinimumDurationSeconds: nullableDurationSeconds(section?.MinimumDurationSeconds ?? section?.minimumDurationSeconds),
    PowerPointSectionFirstSlideId: toNonNegativeInteger(section?.PowerPointSectionFirstSlideId ?? section?.powerPointSectionFirstSlideId, 0),
    CanGrow: section?.CanGrow ?? section?.canGrow ?? true,
    CanShrink: section?.CanShrink ?? section?.canShrink ?? true
  };
}

function normalizeEditBreak(item: any, index: number): any {
  return {
    ...item,
    Name: String(item?.Name || item?.name || `Break ${index + 1}`),
    DurationMinutes: toNonNegativeInteger(item?.DurationMinutes ?? item?.durationMinutes, 15),
    SpecificTime: normalizeTimeText(item?.SpecificTime ?? item?.specificTime),
    BreakSlideIndex: toNonNegativeInteger(item?.BreakSlideIndex ?? item?.breakSlideIndex, 0),
    BreakSlideId: toNonNegativeInteger(item?.BreakSlideId ?? item?.breakSlideId, 0)
  };
}

function normalizeEditSpeaker(speaker: any, index: number): any {
  const name = String(speaker?.Name || speaker?.name || `Speaker ${index + 1}`);
  return {
    ...speaker,
    Id: String(speaker?.Id || speaker?.id || createId("speaker")),
    Name: name,
    Initials: generateInitials(name),
    ColorHex: normalizeSpeakerColor(String(speaker?.ColorHex || speaker?.colorHex || pickSpeakerColor(index))),
    AvatarDataUrl: String(speaker?.AvatarDataUrl || speaker?.avatarDataUrl || "")
  };
}

function populateEditInputs(): void {
  const draft = ensureEditDraft();
  elements.scheduledStartInput.value = normalizeTimeText(draft.StartTime ?? draft.ScheduledStartTime);
  elements.delayedStartSlideInput.value = String(Math.max(1, toNonNegativeInteger(draft.DelayedStartSlideIndex, 1)));
  elements.startOffsetInput.value = formatMinutes(draft.StartOffsetMinutes || 0);
  elements.totalAvailableInput.value = formatMinutes(draft.TotalAvailableMinutes || 0);
}

function commitEditInputs(): void {
  const draft = ensureEditDraft();
  const title = getCurrentPresentationTitle();
  draft.Name = title;
  draft.Title = title;
  draft.StartTime = elements.scheduledStartInput.value.trim();
  delete draft.ScheduledStartTime;
  draft.DelayedStartSlideIndex = Math.max(1, toNonNegativeInteger(elements.delayedStartSlideInput.value, 1));
  draft.StartOffsetMinutes = parseDurationMinutes(elements.startOffsetInput.value, draft.StartOffsetMinutes || 0);
  draft.TotalAvailableMinutes = parseDurationMinutes(elements.totalAvailableInput.value, draft.TotalAvailableMinutes || 0);
}

function markEditDirty(...fieldNames: string[]): void {
  editDirty = true;
  fieldNames
    .filter(fieldName => !!fieldName)
    .forEach(fieldName => editDirtyFields.add(fieldName));
  scheduleEditAutosave();
  setEditStatus("Saving changes...");
}

function setEditStatus(message: string): void {
  elements.editStatus.textContent = message;
  elements.editStatus.hidden = !message;
}

function scheduleEditAutosave(): void {
  if (editAutosaveTimer) {
    window.clearTimeout(editAutosaveTimer);
  }

  editAutosaveTimer = window.setTimeout(() => {
    editAutosaveTimer = 0;
    void flushEditAutosave();
  }, 700);
}

async function flushEditAutosave(): Promise<void> {
  if (!editDirty || editSaveInProgress) {
    return;
  }

  commitEditInputs();
  const draft = normalizeEditModel(ensureEditDraft());

  editSaveInProgress = true;
  const savedDraftJson = JSON.stringify(draft);
  try {
    embeddedPresentation = draft;
    await saveEmbeddedTimerMetadata();
    if (JSON.stringify(normalizeEditModel(ensureEditDraft())) === savedDraftJson) {
      editDraft = cloneJson(draft);
      editDirty = false;
      editDirtyFields.clear();
    }
    if (!editDirty) {
      setEditStatus("");
    }
  } catch (error) {
    setEditStatus(error instanceof Error ? error.message : "Timer metadata could not be saved.");
  } finally {
    editSaveInProgress = false;
    if (editDirty) {
      scheduleEditAutosave();
    }
  }
}

function renderEditPane(): void {
  selectEditTab(activeEditTab, false);
  renderTimingSummary();
  renderActiveEditTab();
}

function renderActiveEditTab(): void {
  switch (activeEditTab) {
    case "sections":
      renderSectionsList();
      break;
    case "breaks":
      renderBreaksList();
      break;
    case "speakers":
      renderSpeakersList();
      break;
  }
}

function renderTimingSummary(): void {
  const draft = ensureEditDraft();
  const totalMinutes = toNonNegativeInteger(draft.TotalAvailableMinutes, 0);
  const breakMinutes = normalizeArray(draft.Breaks).reduce((sum: number, item: any) => sum + toNonNegativeInteger(item.DurationMinutes, 0), 0);
  const slideMinutes = Math.max(0, totalMinutes - breakMinutes);
  const allocatedMinutes = normalizeArray(draft.Sections).reduce((sum: number, item: any) => sum + Math.ceil(toNonNegativeInteger(item.DurationSeconds, 0) / 60), 0);
  const remainingMinutes = slideMinutes - allocatedMinutes;
  elements.breakTotalOutput.textContent = formatMinutes(breakMinutes);
  elements.slideTimeOutput.textContent = formatMinutes(slideMinutes);
  elements.allocatedTimeOutput.textContent = formatMinutes(allocatedMinutes);
  elements.remainingTimeOutput.textContent = formatMinutes(Math.max(0, remainingMinutes));
  elements.overAllocatedWarning.hidden = remainingMinutes >= 0;
}

function renderSectionsList(): void {
  if (sectionDetailsLoading) {
    elements.sectionsList.replaceChildren();
    elements.sectionsList.hidden = true;
    elements.sectionsList.setAttribute("aria-busy", "true");
    elements.sectionsEmptyState.hidden = true;
    elements.sectionsShimmer.hidden = false;
    return;
  }

  const sections = normalizeArray(ensureEditDraft().Sections);
  elements.sectionsList.replaceChildren();
  elements.sectionsList.hidden = false;
  elements.sectionsList.setAttribute("aria-busy", "false");
  elements.sectionsShimmer.hidden = true;
  elements.sectionsEmptyState.hidden = sections.length > 0;
  if (activeSectionEditIndex !== null && (activeSectionEditIndex < 0 || activeSectionEditIndex >= sections.length)) {
    activeSectionEditIndex = null;
  }

  sections.forEach((section: any, index: number) => {
    elements.sectionsList.appendChild(createSectionListItem(section, index));
  });

  if (activeSectionEditIndex !== null) {
    elements.sectionsList.appendChild(createSectionEditForm(sections[activeSectionEditIndex], activeSectionEditIndex));
  }
}

function renderBreaksList(): void {
  if (breakDetailsLoading) {
    elements.breaksList.replaceChildren();
    elements.breaksList.hidden = true;
    elements.breaksList.setAttribute("aria-busy", "true");
    elements.breaksEmptyState.hidden = true;
    elements.breaksShimmer.hidden = false;
    elements.addBreakButton.disabled = true;
    return;
  }

  const breaks = normalizeArray(ensureEditDraft().Breaks);
  elements.breaksList.replaceChildren();
  elements.breaksList.hidden = false;
  elements.breaksList.setAttribute("aria-busy", "false");
  elements.breaksShimmer.hidden = true;
  elements.addBreakButton.disabled = false;
  elements.breaksEmptyState.hidden = breaks.length > 0;
  if (activeBreakEditIndex !== null && (activeBreakEditIndex < 0 || activeBreakEditIndex >= breaks.length)) {
    activeBreakEditIndex = null;
  }

  breaks.forEach((item: any, index: number) => {
    elements.breaksList.appendChild(createBreakListItem(item, index));
  });

  if (activeBreakEditIndex !== null) {
    elements.breaksList.appendChild(createBreakEditForm(breaks[activeBreakEditIndex], activeBreakEditIndex));
  }
}

function renderSpeakersList(): void {
  if (speakerDetailsLoading) {
    elements.speakersList.replaceChildren();
    elements.speakersList.hidden = true;
    elements.speakersList.setAttribute("aria-busy", "true");
    elements.speakersEmptyState.hidden = true;
    elements.speakersShimmer.hidden = false;
    elements.addSpeakerButton.disabled = true;
    return;
  }

  const speakers = normalizeArray(ensureEditDraft().Speakers);
  elements.speakersList.replaceChildren();
  elements.speakersList.hidden = false;
  elements.speakersList.setAttribute("aria-busy", "false");
  elements.speakersShimmer.hidden = true;
  elements.addSpeakerButton.disabled = false;
  elements.speakersEmptyState.hidden = speakers.length > 0;
  if (activeSpeakerEditIndex !== null && (activeSpeakerEditIndex < 0 || activeSpeakerEditIndex >= speakers.length)) {
    activeSpeakerEditIndex = null;
  }

  speakers.forEach((speaker: any, index: number) => {
    const row = createSpeakerListItem(speaker, index, speakers.length);
    elements.speakersList.appendChild(row);
  });

  if (activeSpeakerEditIndex !== null) {
    elements.speakersList.appendChild(createSpeakerEditForm(speakers[activeSpeakerEditIndex], activeSpeakerEditIndex));
  }
}

function createSectionListItem(section: any, index: number): HTMLElement {
  const row = document.createElement("section");
  row.className = "section-details-row";
  row.setAttribute("role", "row");
  row.dataset.kind = "section";
  row.dataset.index = String(index);
  Object.assign(row.style, {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) auto",
    alignItems: "center",
    minHeight: "44px",
    gap: "8px",
    padding: "4px 0 4px 8px"
  });

  const summary = document.createElement("div");
  summary.className = "section-list-summary";
  summary.setAttribute("role", "gridcell");
  Object.assign(summary.style, {
    display: "grid",
    gridTemplateColumns: "auto minmax(0, 1fr)",
    alignItems: "center",
    minWidth: "0",
    gap: "8px"
  });

  const color = document.createElement("span");
  color.className = "section-color-dot";
  color.style.backgroundColor = normalizeSpeakerColor(String(section.ColorHex || ""));
  color.setAttribute("aria-hidden", "true");
  Object.assign(color.style, {
    width: "12px",
    height: "28px",
    border: "1px solid var(--strong-border)"
  });
  summary.appendChild(color);

  const text = document.createElement("div");
  text.className = "section-list-text";
  text.style.minWidth = "0";

  const name = document.createElement("div");
  name.className = "section-list-title";
  name.textContent = String(section.Name || `Section ${index + 1}`);
  Object.assign(name.style, {
    margin: "0",
    fontSize: "14px",
    fontWeight: "400",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  });
  text.appendChild(name);

  const details = document.createElement("p");
  details.textContent = `${formatDurationSeconds(section.DurationSeconds)} · ${normalizeSectionType(String(section.SectionType || "Slides"))}`;
  Object.assign(details.style, {
    margin: "2px 0 0",
    fontSize: "13px",
    color: "var(--muted)"
  });
  text.appendChild(details);

  summary.appendChild(text);
  row.appendChild(summary);

  const commands = document.createElement("div");
  commands.className = "section-row-actions";
  commands.setAttribute("role", "gridcell");
  Object.assign(commands.style, {
    display: "flex",
    alignItems: "center",
    gap: "2px",
    paddingRight: "4px"
  });
  const editButton = createIconCommandButton("Edit section", "edit", "section", index, "edit", false);
  for (const button of [editButton]) {
    Object.assign(button.style, {
      display: "grid",
      placeItems: "center",
      width: "32px",
      minWidth: "32px",
      height: "32px",
      minHeight: "32px",
      padding: "0"
    });
  }
  commands.appendChild(editButton);
  row.appendChild(commands);
  return row;
}

function createSectionEditForm(section: any, index: number): HTMLElement {
  const form = document.createElement("section");
  form.className = "editor-item section-edit-form";
  form.dataset.kind = "section";
  form.dataset.index = String(index);

  const heading = document.createElement("div");
  heading.className = "section-heading";
  const title = document.createElement("h3");
  title.textContent = String(section.Name || `Section ${index + 1}`);
  heading.appendChild(title);
  heading.appendChild(createCommandButton("Done", "section", index, "close-edit", false));
  form.appendChild(heading);

  form.appendChild(createSelectInput(`sectionType${index}`, "Type", section.SectionType, "SectionType", [
    ["Slides", "Slides"],
    ["Demo", "Demo"],
    ["QA", "Q&A"]
  ]));
  form.appendChild(createTextInput(`sectionDuration${index}`, "Duration", formatDurationSeconds(section.DurationSeconds), "DurationSeconds"));
  form.appendChild(createSectionColorInput(index, section.ColorHex));
  return form;
}

function createSectionColorInput(index: number, value: string): HTMLElement {
  const root = document.createElement("div");
  root.className = "field color-field";
  const label = document.createElement("label");
  label.htmlFor = `sectionColor${index}`;
  label.textContent = "Color";
  const row = document.createElement("div");
  row.className = "color-input-row";
  const preview = document.createElement("span");
  preview.className = "section-color-preview";
  preview.style.backgroundColor = normalizeSpeakerColor(value);
  preview.setAttribute("aria-hidden", "true");
  const input = document.createElement("input");
  input.id = `sectionColor${index}`;
  input.type = "text";
  input.value = normalizeSpeakerColor(value);
  input.dataset.field = "ColorHex";
  row.append(preview, input);
  root.append(label, row);
  return root;
}

function createBreakListItem(item: any, index: number): HTMLElement {
  const row = document.createElement("section");
  row.className = "break-details-row";
  row.setAttribute("role", "row");
  row.dataset.kind = "break";
  row.dataset.index = String(index);

  const summary = document.createElement("div");
  summary.className = "break-list-summary";
  summary.setAttribute("role", "gridcell");

  const marker = document.createElement("span");
  marker.className = "break-marker";
  marker.textContent = "||";
  marker.setAttribute("aria-hidden", "true");
  summary.appendChild(marker);

  const text = document.createElement("div");
  text.className = "break-list-text";

  const name = document.createElement("div");
  name.className = "break-list-title";
  name.textContent = String(item.Name || `Break ${index + 1}`);
  text.appendChild(name);

  const details = document.createElement("p");
  details.textContent = getBreakSummary(item);
  text.appendChild(details);

  summary.appendChild(text);
  row.appendChild(summary);

  const commands = document.createElement("div");
  commands.className = "break-row-actions";
  commands.setAttribute("role", "gridcell");
  commands.appendChild(createIconCommandButton("Edit break", "edit", "break", index, "edit", false));
  commands.appendChild(createIconCommandButton("Remove break", "delete", "break", index, "remove", false));
  row.appendChild(commands);
  return row;
}

function createBreakEditForm(item: any, index: number): HTMLElement {
  const form = document.createElement("section");
  form.className = "editor-item break-edit-form";
  form.dataset.kind = "break";
  form.dataset.index = String(index);

  const heading = document.createElement("div");
  heading.className = "section-heading";
  const title = document.createElement("h3");
  title.textContent = "Edit break";
  heading.appendChild(title);
  heading.appendChild(createCommandButton("Done", "break", index, "close-edit", false));
  form.appendChild(heading);

  form.appendChild(createTextInput(`breakName${index}`, "Name", item.Name, "Name"));
  form.appendChild(createTextInput(`breakDuration${index}`, "Duration", formatMinutes(item.DurationMinutes), "DurationMinutes"));
  form.appendChild(createTextInput(`breakSpecificTime${index}`, "Time (optional)", normalizeTimeText(item.SpecificTime), "SpecificTime", "HH:MM"));
  form.appendChild(createOptionalNumberInput(`breakSlide${index}`, "Slide # (optional)", item.BreakSlideIndex, "BreakSlideIndex", 1));
  return form;
}

function getBreakSummary(item: any): string {
  const parts = [formatMinutes(item.DurationMinutes)];
  const specificTime = normalizeTimeText(item.SpecificTime);
  const breakSlideIndex = toNonNegativeInteger(item.BreakSlideIndex, 0);
  if (specificTime) {
    parts.push(`At ${specificTime}`);
  }

  if (breakSlideIndex > 0) {
    parts.push(`Slide ${breakSlideIndex}`);
  }

  return parts.join(" · ");
}

function createSpeakerListItem(speaker: any, index: number, _count: number): HTMLElement {
  const row = document.createElement("section");
  row.className = "speaker-details-row";
  row.setAttribute("role", "row");
  row.dataset.kind = "speaker";
  row.dataset.index = String(index);

  const summary = document.createElement("div");
  summary.className = "speaker-list-summary";
  summary.setAttribute("role", "gridcell");
  summary.appendChild(createSpeakerAvatar(speaker));

  const text = document.createElement("div");
  text.className = "speaker-list-text";

  const name = document.createElement("h3");
  name.textContent = getSpeakerValue(speaker, "name") || "Speaker";
  text.appendChild(name);

  summary.appendChild(text);
  row.appendChild(summary);

  const commands = document.createElement("div");
  commands.className = "speaker-row-actions";
  commands.setAttribute("role", "gridcell");
  commands.appendChild(createIconCommandButton("Edit speaker", "edit", "speaker", index, "edit", false));
  commands.appendChild(createIconCommandButton("Remove speaker", "delete", "speaker", index, "remove", false));
  row.appendChild(commands);
  return row;
}

function createSpeakerEditForm(speaker: any, index: number): HTMLElement {
  const form = document.createElement("section");
  form.className = "editor-item speaker-edit-form";
  form.dataset.kind = "speaker";
  form.dataset.index = String(index);

  const heading = document.createElement("div");
  heading.className = "section-heading";
  const title = document.createElement("h3");
  title.textContent = "Edit speaker";
  heading.appendChild(title);
  heading.appendChild(createCommandButton("Done", "speaker", index, "close-edit", false));
  form.appendChild(heading);

  const preview = document.createElement("div");
  preview.className = "speaker-edit-preview";
  preview.appendChild(createSpeakerAvatar(speaker));
  const previewText = document.createElement("p");
  previewText.textContent = `${getSpeakerValue(speaker, "name") || "Speaker"} (${generateInitials(getSpeakerValue(speaker, "name"))})`;
  preview.appendChild(previewText);
  form.appendChild(preview);

  form.appendChild(createTextInput(`speakerName${index}`, "Name", speaker.Name, "Name"));
  form.appendChild(createSpeakerColorInput(index, speaker.ColorHex));
  form.appendChild(createSpeakerPhotoInput(index, speaker));
  return form;
}

function createSpeakerColorInput(index: number, value: string): HTMLElement {
  const root = document.createElement("div");
  root.className = "field color-field";
  const label = document.createElement("label");
  label.htmlFor = `speakerColor${index}`;
  label.textContent = "Color";
  const row = document.createElement("div");
  row.className = "color-input-row";
  const preview = document.createElement("span");
  preview.className = "speaker-color-preview";
  preview.style.backgroundColor = normalizeSpeakerColor(value);
  preview.setAttribute("aria-hidden", "true");
  const input = document.createElement("input");
  input.id = `speakerColor${index}`;
  input.type = "text";
  input.value = normalizeSpeakerColor(value);
  input.dataset.field = "ColorHex";
  row.append(preview, input);
  root.append(label, row);
  return root;
}

function createSpeakerPhotoInput(index: number, speaker: any): HTMLElement {
  const root = document.createElement("div");
  root.className = "field photo-field";
  const label = document.createElement("span");
  label.textContent = "Photo";

  const row = document.createElement("div");
  row.className = "photo-command-row";

  const browse = createCommandButton("Browse...", "speaker", index, "browse-photo", false);
  const clear = createCommandButton("Clear", "speaker", index, "clear-photo", !getSpeakerValue(speaker, "avatarDataUrl"));
  const status = document.createElement("span");
  status.className = "photo-status";
  status.textContent = getSpeakerValue(speaker, "avatarDataUrl") ? "" : "No photo - using color and initials";
  status.hidden = !!getSpeakerValue(speaker, "avatarDataUrl");

  const input = document.createElement("input");
  input.id = `speakerPhoto${index}`;
  input.type = "file";
  input.accept = "image/*";
  input.dataset.action = "select-photo";
  input.className = "visually-hidden";

  row.append(browse, clear, status, input);
  root.append(label, row);
  return root;
}

function createEditorItem(kind: string, index: number, title: string): HTMLElement {
  const item = document.createElement("section");
  item.className = "editor-item";
  item.dataset.kind = kind;
  item.dataset.index = String(index);

  const heading = document.createElement("h3");
  heading.textContent = title;
  item.appendChild(heading);
  return item;
}

function createTextInput(id: string, labelText: string, value: string, field: string, placeholder = ""): HTMLElement {
  const root = document.createElement("div");
  root.className = "field";
  const label = document.createElement("label");
  label.htmlFor = id;
  label.textContent = labelText;
  const input = document.createElement("input");
  input.id = id;
  input.type = "text";
  input.value = value;
  input.dataset.field = field;
  if (placeholder) {
    input.placeholder = placeholder;
  }

  root.append(label, input);
  return root;
}

function createNumberInput(id: string, labelText: string, value: number, field: string, min: number): HTMLElement {
  const root = createTextInput(id, labelText, String(value || min), field);
  const input = root.querySelector("input");
  if (input) {
    input.type = "number";
    input.inputMode = "numeric";
    input.min = String(min);
    input.step = "1";
  }
  return root;
}

function createOptionalNumberInput(id: string, labelText: string, value: number, field: string, min: number): HTMLElement {
  const root = createTextInput(id, labelText, value > 0 ? String(value) : "", field);
  const input = root.querySelector("input");
  if (input) {
    input.type = "number";
    input.inputMode = "numeric";
    input.min = String(min);
    input.step = "1";
  }
  return root;
}

function createSelectInput(id: string, labelText: string, value: string, field: string, options: Array<[string, string]>): HTMLElement {
  const root = document.createElement("div");
  root.className = "field";
  const label = document.createElement("label");
  label.htmlFor = id;
  label.textContent = labelText;
  const select = document.createElement("select");
  select.id = id;
  select.dataset.field = field;
  for (const [optionValue, optionLabel] of options) {
    const option = document.createElement("option");
    option.value = optionValue;
    option.textContent = optionLabel;
    select.appendChild(option);
  }
  select.value = value;
  root.append(label, select);
  return root;
}

function createRowCommands(kind: string, index: number, count: number): HTMLElement {
  const row = document.createElement("div");
  row.className = "row-commands";
  row.appendChild(createCommandButton("Move up", kind, index, "move-up", index === 0));
  row.appendChild(createCommandButton("Move down", kind, index, "move-down", index >= count - 1));
  row.appendChild(createCommandButton(kind === "speaker" ? "Remove speaker" : "Remove break", kind, index, "remove", false));
  return row;
}

function createCommandButton(text: string, kind: string, index: number, action: string, disabled: boolean): HTMLButtonElement {
  const button = document.createElement("button");
  button.type = "button";
  button.textContent = text;
  button.dataset.kind = kind;
  button.dataset.index = String(index);
  button.dataset.action = action;
  button.disabled = disabled;
  return button;
}

function createIconCommandButton(label: string, icon: "edit" | "delete", kind: string, index: number, action: string, disabled: boolean): HTMLButtonElement {
  const button = createCommandButton("", kind, index, action, disabled);
  button.className = `icon-button icon-button-${icon}`;
  button.setAttribute("aria-label", label);
  button.title = label;
  const glyph = document.createElement("span");
  glyph.className = "icon-button-glyph";
  glyph.setAttribute("aria-hidden", "true");
  button.appendChild(glyph);
  return button;
}

function handleEditorInput(collectionName: "Sections" | "Breaks" | "Speakers", event: Event): void {
  const target = event.target as HTMLInputElement | HTMLSelectElement | null;
  if (!target?.dataset.field) {
    return;
  }

  const item = getEditorItem(target);
  if (!item) {
    return;
  }

  updateEditorValue(collectionName, item.index, target.dataset.field, target.value);
  if (collectionName === "Speakers" && target.dataset.field === "Name") {
    updateSpeakerEditPreview(target, item.index);
  }

  if ((collectionName === "Sections" || collectionName === "Speakers") && target.dataset.field === "ColorHex") {
    const preview = target.closest<HTMLElement>(".color-input-row")?.querySelector<HTMLElement>(".section-color-preview, .speaker-color-preview");
    if (preview) {
      preview.style.backgroundColor = normalizeSpeakerColor(target.value);
    }
  }

  markEditDirty();
  renderTimingSummary();
}

async function handleSpeakerListChange(event: Event): Promise<void> {
  const target = event.target as HTMLInputElement | HTMLSelectElement | null;
  if (target instanceof HTMLInputElement && target.type === "file" && target.dataset.action === "select-photo") {
    await handleSpeakerPhotoSelected(target);
    return;
  }

  handleEditorInput("Speakers", event);
}

function handleEditorCommand(collectionName: "Sections" | "Breaks" | "Speakers", event: Event): void {
  const button = (event.target as HTMLElement | null)?.closest<HTMLButtonElement>("button[data-action]");
  if (!button) {
    return;
  }

  const item = getEditorItem(button);
  if (!item) {
    return;
  }

  const draft = ensureEditDraft();
  const items = normalizeArray(draft[collectionName]);
  if (collectionName === "Sections" && button.dataset.action === "edit") {
    activeSectionEditIndex = item.index;
    renderEditPane();
    window.setTimeout(() => document.getElementById(`sectionType${activeSectionEditIndex}`)?.focus(), 0);
    return;
  }

  if (collectionName === "Sections" && button.dataset.action === "close-edit") {
    activeSectionEditIndex = null;
    void flushEditAutosave();
    renderEditPane();
    return;
  }

  if (collectionName === "Sections") {
    return;
  }

  if (collectionName === "Breaks" && button.dataset.action === "edit") {
    activeBreakEditIndex = item.index;
    renderEditPane();
    window.setTimeout(() => document.getElementById(`breakName${activeBreakEditIndex}`)?.focus(), 0);
    return;
  }

  if (collectionName === "Breaks" && button.dataset.action === "close-edit") {
    activeBreakEditIndex = null;
    renderEditPane();
    return;
  }

  if (collectionName === "Speakers" && button.dataset.action === "edit") {
    activeSpeakerEditIndex = item.index;
    renderEditPane();
    window.setTimeout(() => document.getElementById(`speakerName${activeSpeakerEditIndex}`)?.focus(), 0);
    return;
  }

  if (collectionName === "Speakers" && button.dataset.action === "close-edit") {
    activeSpeakerEditIndex = null;
    renderEditPane();
    return;
  }

  if (collectionName === "Speakers" && button.dataset.action === "browse-photo") {
    document.getElementById(`speakerPhoto${item.index}`)?.click();
    return;
  }

  if (collectionName === "Speakers" && button.dataset.action === "clear-photo") {
    const speaker = items[item.index];
    if (!speaker) {
      return;
    }

    speaker.AvatarDataUrl = "";
    markEditDirty();
    renderEditPane();
    return;
  }

  if (button.dataset.action === "remove") {
    const [removed] = items.splice(item.index, 1);
    if (collectionName === "Speakers" && removed) {
      removeSlideSpeakerAssignmentsForSpeaker(draft, removed);
    }

    if (collectionName === "Speakers" && activeSpeakerEditIndex !== null) {
      if (activeSpeakerEditIndex === item.index) {
        activeSpeakerEditIndex = null;
      } else if (activeSpeakerEditIndex > item.index) {
        activeSpeakerEditIndex -= 1;
      }
    }

    if (collectionName === "Breaks" && activeBreakEditIndex !== null) {
      if (activeBreakEditIndex === item.index) {
        activeBreakEditIndex = null;
      } else if (activeBreakEditIndex > item.index) {
        activeBreakEditIndex -= 1;
      }
    }
  } else {
    return;
  }

  draft[collectionName] = items;
  markEditDirty();
  renderEditPane();
}

function removeSlideSpeakerAssignmentsForSpeaker(draft: any, speaker: any): void {
  const slideSpeakers = draft?.SlideSpeakers || draft?.slideSpeakers;
  if (!slideSpeakers || typeof slideSpeakers !== "object") {
    return;
  }

  for (const [slide, speakerRef] of Object.entries(slideSpeakers)) {
    if (matchesSpeaker(speaker, String(speakerRef || ""))) {
      delete slideSpeakers[slide];
    }
  }

  draft.SlideSpeakers = slideSpeakers;
}

function getEditorItem(element: HTMLElement): { index: number; kind: string } | null {
  const item = element.closest<HTMLElement>("[data-kind][data-index]");
  const index = Number.parseInt(item?.dataset.index || "", 10);
  const kind = item?.dataset.kind || "";
  return Number.isFinite(index) && kind ? { index, kind } : null;
}

function updateEditorValue(collectionName: "Sections" | "Breaks" | "Speakers", index: number, field: string, value: string): void {
  const items = normalizeArray(ensureEditDraft()[collectionName]);
  const item = items[index];
  if (!item) {
    return;
  }

  if (collectionName === "Sections" && field === "DurationSeconds") {
    item.DurationSeconds = parseDurationSeconds(value, item.DurationSeconds || 0);
  } else if (collectionName === "Breaks" && field === "DurationMinutes") {
    item.DurationMinutes = parseDurationMinutes(value, item.DurationMinutes || 0);
  } else if (collectionName === "Breaks" && field === "BreakSlideIndex") {
    item.BreakSlideIndex = value.trim() ? toNonNegativeInteger(value, item.BreakSlideIndex || 0) : 0;
  } else if (collectionName === "Speakers" && field === "Name") {
    item.Name = value;
    item.Initials = generateInitials(value);
  } else if (field === "ColorHex") {
    item.ColorHex = normalizeSpeakerColor(value);
  } else if (field === "SectionType") {
    item.SectionType = normalizeSectionType(value);
  } else {
    item[field] = value;
  }
}

function updateSpeakerEditPreview(input: HTMLInputElement | HTMLSelectElement, index: number): void {
  const speaker = normalizeArray(ensureEditDraft().Speakers)[index];
  if (!speaker) {
    return;
  }

  const form = input.closest<HTMLElement>(".speaker-edit-form");
  const previewText = form?.querySelector<HTMLElement>(".speaker-edit-preview p");
  if (previewText) {
    previewText.textContent = `${String(speaker.Name || "Speaker")} (${String(speaker.Initials || generateInitials(speaker.Name || ""))})`;
  }

  const avatar = form?.querySelector<HTMLElement>(".speaker-avatar");
  if (avatar && !avatar.querySelector("img")) {
    avatar.textContent = String(speaker.Initials || generateInitials(speaker.Name || ""));
  }
}

async function handleSpeakerPhotoSelected(input: HTMLInputElement): Promise<void> {
  const item = getEditorItem(input);
  const file = input.files?.[0] || null;
  if (!item || !file) {
    return;
  }

  if (!file.type.startsWith("image/")) {
    setEditStatus("Choose an image file for the speaker photo.");
    input.value = "";
    return;
  }

  const speakers = normalizeArray(ensureEditDraft().Speakers);
  const speaker = speakers[item.index];
  if (!speaker) {
    return;
  }

  try {
    const avatarDataUrl = await readFileAsDataUrl(file);
    speaker.AvatarDataUrl = avatarDataUrl;
  } catch {
    setEditStatus("The speaker photo could not be read.");
    input.value = "";
    return;
  }

  speaker.Initials = generateInitials(String(speaker.Name || ""));
  ensureEditDraft().Speakers = speakers;
  markEditDirty();
  renderEditPane();
}

function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(String(reader.result || "")));
    reader.addEventListener("error", () => reject(reader.error || new Error("The speaker photo could not be read.")));
    reader.readAsDataURL(file);
  });
}

function cloneJson<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}

function normalizeArray(value: any): any[] {
  return Array.isArray(value) ? value : [];
}

function toNonNegativeInteger(value: any, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? Math.trunc(parsed) : fallback;
}

function nullableDurationSeconds(value: any): number | null {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.trunc(parsed) : null;
}

function normalizeTimeText(value: any): string {
  if (!value) {
    return "";
  }

  if (typeof value === "string") {
    return value.trim();
  }

  if (typeof value === "object" && "hour" in value && "minute" in value) {
    return `${String(value.hour).padStart(2, "0")}:${String(value.minute).padStart(2, "0")}`;
  }

  return String(value);
}

function pickSectionColor(index: number): string {
  const colors = ["#E53935", "#1E88E5", "#43A047", "#FB8C00", "#8E24AA", "#00ACC1", "#FFB300", "#6D4C41"];
  return colors[index % colors.length];
}

function pickSpeakerColor(index: number): string {
  const colors = ["#1E88E5", "#E53935", "#43A047", "#8E24AA", "#00ACC1", "#FB8C00", "#6D4C41", "#E91E63"];
  return colors[index % colors.length];
}

function normalizeSectionType(value: string): string {
  const normalized = value.trim().toLowerCase();
  if (normalized === "demo") {
    return "Demo";
  }

  if (normalized === "qa" || normalized === "q&a") {
    return "QA";
  }

  return "Slides";
}

function createPresentationBreak(): any {
  return {
    Name: "Break",
    DurationMinutes: 15,
    SpecificTime: "",
    BreakSlideIndex: 0,
    BreakSlideId: 0
  };
}

function createPresentationSpeaker(): any {
  const name = "Speaker";
  return {
    Id: createId("speaker"),
    Name: name,
    Initials: generateInitials(name),
    ColorHex: pickSpeakerColor(normalizeArray(ensureEditDraft().Speakers).length),
    AvatarDataUrl: ""
  };
}

function createId(prefix: string): string {
  const random = typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return `${prefix}-${random}`;
}

function generateInitials(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) {
    return "SP";
  }

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

function formatMinutes(totalMinutes: number): string {
  const value = Math.max(0, Math.trunc(totalMinutes || 0));
  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

function parseDurationMinutes(value: string, fallback: number): number {
  const seconds = parseDurationSeconds(value, fallback * 60);
  return Math.max(0, Math.ceil(seconds / 60));
}

function parseDurationSeconds(value: string, fallback: number): number {
  const text = String(value || "").trim().toLowerCase();
  if (!text) {
    return fallback;
  }

  const tokenMatches = [...text.matchAll(/(\d+(?:\.\d+)?)\s*(h|hr|hrs|hour|hours|m|min|mins|minute|minutes|s|sec|secs|second|seconds)\b/g)];
  if (tokenMatches.length > 0) {
    return Math.max(0, Math.round(tokenMatches.reduce((sum, match) => {
      const amount = Number(match[1]);
      const unit = match[2][0];
      return sum + (unit === "h" ? amount * 3600 : unit === "m" ? amount * 60 : amount);
    }, 0)));
  }

  if (/^\d+(\.\d+)?$/.test(text)) {
    return Math.max(0, Math.round(Number(text) * 60));
  }

  const parts = text.split(":").map(part => Number(part));
  if (parts.length === 2 && parts.every(Number.isFinite)) {
    return Math.max(0, Math.round((parts[0] * 60 + parts[1]) * 60));
  }

  if (parts.length === 3 && parts.every(Number.isFinite)) {
    return Math.max(0, Math.round(parts[0] * 3600 + parts[1] * 60 + parts[2]));
  }

  return fallback;
}

function formatDurationSeconds(totalSeconds: number): string {
  const value = Math.max(0, Math.trunc(totalSeconds || 0));
  if (value % 60 === 0) {
    return formatMinutes(value / 60);
  }

  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const seconds = value % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

function markEmbeddedMetadataReady(): void {
  sectionDetailsLoading = false;
  breakDetailsLoading = false;
  speakerDetailsLoading = false;
  shareSpeakersLoading = false;
}

function startPowerPointPackageHydration(reason: string): void {
  updatePowerPointPackageLoadingState();
  if (!embeddedMetadataLoaded) {
    addDiagnostic(`Deferred PowerPoint package metadata hydration for ${reason} until embedded metadata is loaded.`);
    return;
  }

  if (powerPointPackageHydrated || powerPointPackageHydrationPromise) {
    return;
  }

  addDiagnostic(`PowerPoint package metadata hydration started for ${reason}.`);
  powerPointPackageHydrationPromise = hydrateEmbeddedPresentationFromPowerPointPackage()
    .then(() => {
      addDiagnostic("PowerPoint package metadata hydration finished.");
    })
    .catch(error => {
      addDiagnostic(`PowerPoint package metadata hydration failed: ${error instanceof Error ? error.message : "unknown error"}.`);
    })
    .finally(() => {
      powerPointPackageHydrationPromise = null;
      markEmbeddedMetadataReady();
      if (!editDirty) {
        editDraft = null;
      }

      renderShareSpeakers();
      void updateEditView();
    });
}

function updatePowerPointPackageLoadingState(): void {
  if (powerPointPackageHydrated) {
    markEmbeddedMetadataReady();
    return;
  }

  const model = getOrCreateEmbeddedPresentation();
  const hasSections = normalizeArray(model.Sections || model.sections).length > 0;
  const hasSpeakers = normalizeArray(model.Speakers || model.speakers).length > 0;

  if (activeView === "share" && !hasSpeakers) {
    shareSpeakersLoading = true;
    renderShareSpeakers();
  }

  if (activeView === "edit") {
    if (activeEditTab === "sections" && !hasSections) {
      sectionDetailsLoading = true;
    }

    if (activeEditTab === "speakers" && !hasSpeakers) {
      speakerDetailsLoading = true;
    }

    breakDetailsLoading = false;
  }
}

async function hydrateEmbeddedPresentationFromPowerPointPackage(): Promise<void> {
  if (powerPointPackageHydrated) {
    return;
  }

  powerPointPackageHydrated = true;

  try {
    let imported = { Sections: [] as any[], Speakers: [] as any[], SlideSpeakers: {} as Record<string, string> };
    const packageData = await readCurrentPowerPointPackage();
    if (packageData) {
      try {
        imported = await importTimerMetadataFromPowerPointPackage(packageData);
      } catch (error) {
        addDiagnostic(`PowerPoint package metadata import failed; trying slide fallback: ${error instanceof Error ? error.message : "unknown error"}.`);
      }
    }

    if (imported.Sections.length === 0) {
      imported.Sections = await readPowerPointSectionsFromOfficeApi();
    }

    if (editDirty || editSaveInProgress) {
      addDiagnostic("Skipped PowerPoint metadata hydration because editor changes are pending.");
      return;
    }

    const model = getOrCreateEmbeddedPresentation();
    const hasSpeakers = normalizeArray(model.Speakers || model.speakers).length > 0;
    const hasSlideSpeakers = model.SlideSpeakers && typeof model.SlideSpeakers === "object" && Object.keys(model.SlideSpeakers).length > 0;
    let changed = false;
    if (imported.Sections.length > 0) {
      model.Sections = mergePowerPointSectionsWithTimerMetadata(
        imported.Sections,
        normalizeArray(model.Sections || model.sections));
      changed = true;
    }

    if (!hasSlideSpeakers && Object.keys(imported.SlideSpeakers).length > 0) {
      model.SlideSpeakers = imported.SlideSpeakers;
      changed = true;
    }

    if (!hasSpeakers && imported.Speakers.length > 0) {
      model.Speakers = imported.Speakers;
      changed = true;
    }

    if (changed) {
      embeddedPresentation = normalizeEditModel(model);
      addDiagnostic(`Imported PowerPoint metadata from current deck. Sections=${imported.Sections.length}; Speakers=${imported.Speakers.length}.`);
    }
  } catch (error) {
    addDiagnostic(`PowerPoint package metadata import failed: ${error instanceof Error ? error.message : "unknown error"}.`);
  }
}

function readCurrentPowerPointPackage(): Promise<Uint8Array | null> {
  const documentApi = Office.context?.document;
  const fileType = Office.FileType?.Compressed;
  if (!documentApi?.getFileAsync || !fileType) {
    return Promise.resolve(null);
  }

  return new Promise(resolve => {
    documentApi.getFileAsync(fileType, { sliceSize: 65536 }, (result: any) => {
      if (result?.status !== Office.AsyncResultStatus.Succeeded || !result.value) {
        resolve(null);
        return;
      }

      const file = result.value;
      const chunks: Uint8Array[] = [];
      let sliceIndex = 0;

      const closeFile = (): void => {
        try {
          file.closeAsync?.();
        } catch {
        }
      };

      const readNextSlice = (): void => {
        if (sliceIndex >= file.sliceCount) {
          closeFile();
          resolve(concatBytes(chunks));
          return;
        }

        file.getSliceAsync(sliceIndex, (sliceResult: any) => {
          if (sliceResult?.status !== Office.AsyncResultStatus.Succeeded) {
            closeFile();
            resolve(null);
            return;
          }

          chunks.push(sliceDataToBytes(sliceResult.value?.data));
          sliceIndex++;
          readNextSlice();
        });
      };

      readNextSlice();
    });
  });
}

function sliceDataToBytes(data: any): Uint8Array {
  if (data instanceof Uint8Array) {
    return data;
  }

  if (Array.isArray(data)) {
    return new Uint8Array(data);
  }

  if (data instanceof ArrayBuffer) {
    return new Uint8Array(data);
  }

  if (typeof data === "string") {
    const bytes = new Uint8Array(data.length);
    for (let i = 0; i < data.length; i++) {
      bytes[i] = data.charCodeAt(i) & 0xff;
    }
    return bytes;
  }

  return new Uint8Array();
}

async function readPowerPointSectionsFromOfficeApi(): Promise<any[]> {
  if (typeof PowerPoint === "undefined" || typeof PowerPoint.run !== "function") {
    return [];
  }

  try {
    let slideCount = 0;
    let firstSlideId = 0;
    await PowerPoint.run(async (context: any) => {
      const slides = context?.presentation?.slides;
      if (!slides?.load) {
        return;
      }

      slides.load("items");
      await context.sync();
      const items = Array.isArray(slides.items) ? slides.items : [];
      slideCount = items.length;
      firstSlideId = toNonNegativeInteger(items[0]?.id, 0);
    });

    return slideCount > 0
      ? [createImportedSection("Slides", slideCount, firstSlideId, 0)]
      : [];
  } catch (error) {
    addDiagnostic(`PowerPoint slide fallback import failed: ${error instanceof Error ? error.message : "unknown error"}.`);
    return [];
  }
}

function concatBytes(chunks: Uint8Array[]): Uint8Array {
  const length = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
  const result = new Uint8Array(length);
  let offset = 0;
  for (const chunk of chunks) {
    result.set(chunk, offset);
    offset += chunk.length;
  }

  return result;
}

async function importTimerMetadataFromPowerPointPackage(packageData: Uint8Array): Promise<any> {
  if (typeof JSZip === "undefined") {
    return { Sections: [], Speakers: [], SlideSpeakers: {} };
  }

  const zip = await JSZip.loadAsync(packageData);
  const embeddedTimer = await readEmbeddedTimerMetadataFromPowerPointPackage(zip);
  const presentationXml = await readZipText(zip, "ppt/presentation.xml");
  const presentationRelsXml = await readZipText(zip, "ppt/_rels/presentation.xml.rels");
  if (!presentationXml || !presentationRelsXml) {
    return embeddedTimer || { Sections: [], Speakers: [], SlideSpeakers: {} };
  }

  const presentationDoc = parseXml(presentationXml);
  const presentationRels = parseRelationshipMap(presentationRelsXml, "ppt/presentation.xml");
  const slideInfos = await readPowerPointSlideInfos(zip, presentationDoc, presentationRels);
  const sections = readPowerPointSections(presentationDoc, slideInfos);
  const slideSpeakers = await readPowerPointSlideSpeakers(zip, slideInfos);
  const embeddedSections = normalizeArray(embeddedTimer?.Sections || embeddedTimer?.sections);
  const embeddedSpeakers = normalizeArray(embeddedTimer?.Speakers || embeddedTimer?.speakers);
  const speakers = embeddedSpeakers.length > 0
    ? embeddedSpeakers
    : buildSpeakersFromSlideSpeakers(slideSpeakers);
  return {
    ...(embeddedTimer || {}),
    Sections: sections.length > 0
      ? mergePowerPointSectionsWithTimerMetadata(sections, embeddedSections)
      : embeddedSections,
    Speakers: speakers,
    SlideSpeakers: Object.keys(slideSpeakers).length > 0
      ? slideSpeakers
      : (embeddedTimer?.SlideSpeakers || embeddedTimer?.slideSpeakers || {})
  };
}

function mergePowerPointSectionsWithTimerMetadata(powerPointSections: any[], timerSections: any[]): any[] {
  const normalizedTimerSections = normalizeArray(timerSections).map(normalizeEditSection);
  return powerPointSections.map((powerPointSection, index) => {
    const existing = findMatchingTimerSection(powerPointSection, normalizedTimerSections, index);
    return normalizeEditSection({
      ...powerPointSection,
      DurationSeconds: existing?.DurationSeconds ?? powerPointSection.DurationSeconds,
      ColorHex: existing?.ColorHex ?? powerPointSection.ColorHex,
      SectionType: existing?.SectionType ?? powerPointSection.SectionType,
      MinimumDurationSeconds: existing?.MinimumDurationSeconds ?? powerPointSection.MinimumDurationSeconds,
      CanGrow: existing?.CanGrow ?? powerPointSection.CanGrow,
      CanShrink: existing?.CanShrink ?? powerPointSection.CanShrink
    }, index);
  });
}

function findMatchingTimerSection(powerPointSection: any, timerSections: any[], index: number): any | null {
  const firstSlideId = toNonNegativeInteger(powerPointSection?.PowerPointSectionFirstSlideId ?? powerPointSection?.powerPointSectionFirstSlideId, 0);
  if (firstSlideId > 0) {
    const byFirstSlide = timerSections.find(section =>
      toNonNegativeInteger(section.PowerPointSectionFirstSlideId ?? section.powerPointSectionFirstSlideId, 0) === firstSlideId);
    if (byFirstSlide) {
      return byFirstSlide;
    }
  }

  const name = String(powerPointSection?.Name || powerPointSection?.name || "").trim();
  if (name) {
    const byName = timerSections.find(section =>
      String(section.Name || section.name || "").trim().toLowerCase() === name.toLowerCase());
    if (byName) {
      return byName;
    }
  }

  return timerSections[index] || null;
}

async function readZipText(zip: any, path: string): Promise<string> {
  const file = zip.file(path);
  return file ? await file.async("text") : "";
}

async function readEmbeddedTimerMetadataFromPowerPointPackage(zip: any): Promise<any | null> {
  const files = Object.values(zip.files || {}) as any[];
  const customXmlFiles = files.filter(file =>
    !file.dir &&
    /^customXml\/.+\.xml$/i.test(String(file.name || "")));

  for (const file of customXmlFiles) {
    const xml = await file.async("text");
    const presentationJson = extractPresentationJson(xml);
    if (!presentationJson) {
      continue;
    }

    try {
      return JSON.parse(presentationJson);
    } catch {
      addDiagnostic(`Embedded Timerinator metadata in ${file.name} could not be parsed.`);
    }
  }

  return null;
}

async function readPowerPointSlideInfos(zip: any, presentationDoc: Document, presentationRels: Map<string, string>): Promise<any[]> {
  const slideIdElements = descendantsByLocalName(presentationDoc, "sldId");
  const slideInfos: any[] = [];
  let visibleIndex = 0;
  for (let index = 0; index < slideIdElements.length; index++) {
    const element = slideIdElements[index];
    const slideId = toNonNegativeInteger(getAttributeByLocalName(element, "id"), 0);
    const relationshipId = getAttributeByLocalName(element, "id", "http://schemas.openxmlformats.org/officeDocument/2006/relationships");
    const path = presentationRels.get(relationshipId) || "";
    const slideXml = path ? await readZipText(zip, path) : "";
    const slideDoc = slideXml ? parseXml(slideXml) : null;
    const hidden = slideDoc ? isHiddenPowerPointSlide(slideDoc) : false;
    if (!hidden) {
      visibleIndex++;
    }

    slideInfos.push({
      rawIndex: index + 1,
      visibleIndex: hidden ? 0 : visibleIndex,
      slideId,
      relationshipId,
      path,
      hidden
    });
  }

  return slideInfos;
}

function readPowerPointSections(presentationDoc: Document, slideInfos: any[]): any[] {
  const sectionList = descendantsByLocalName(presentationDoc, "sectionLst")[0];
  const sectionElements = sectionList
    ? Array.from(sectionList.childNodes).filter(node => node.nodeType === Node.ELEMENT_NODE && (node as Element).localName === "section") as Element[]
    : [];

  if (sectionElements.length === 0) {
    const visibleSlides = slideInfos.filter(slide => !slide.hidden).length;
    return visibleSlides > 0
      ? [createImportedSection("Slides", visibleSlides, 0, 0)]
      : [];
  }

  const slideById = new Map(slideInfos.map(slide => [String(slide.slideId), slide]));
  return sectionElements.map((section, index) => {
    const name = getAttributeByLocalName(section, "name") || `Section ${index + 1}`;
    const sectionSlideIds = descendantsByLocalName(section, "sldId")
      .map(element => getAttributeByLocalName(element, "id"))
      .filter(value => !!value);
    const sectionSlides = sectionSlideIds
      .map(id => slideById.get(String(id)))
      .filter(slide => !!slide);
    const visibleSlides = sectionSlides.filter(slide => !slide.hidden);
    const firstSlide = sectionSlides[0] || null;
    return createImportedSection(
      name,
      Math.max(1, visibleSlides.length || sectionSlides.length),
      firstSlide?.slideId || 0,
      index);
  });
}

function createImportedSection(name: string, slideCount: number, firstSlideId: number, index: number): any {
  return {
    Name: name,
    DurationSeconds: 300,
    ColorHex: pickSectionColor(index),
    Slides: Math.max(1, slideCount),
    SectionType: inferSectionType(name),
    MinimumDurationSeconds: null,
    PowerPointSectionFirstSlideId: firstSlideId,
    CanGrow: true,
    CanShrink: true
  };
}

function inferSectionType(name: string): string {
  if (/\bq\s*&?\s*a\b|questions?/i.test(name)) {
    return "QA";
  }

  if (/\bdemo\b/i.test(name)) {
    return "Demo";
  }

  return "Slides";
}

async function readPowerPointSlideSpeakers(zip: any, slideInfos: any[]): Promise<Record<string, string>> {
  const rawSpeakerMap = new Map<number, string>();
  for (const slide of slideInfos) {
    if (slide.hidden || !slide.path) {
      continue;
    }

    const slideRelsPath = getRelationshipsPath(slide.path);
    const slideRelsXml = await readZipText(zip, slideRelsPath);
    if (!slideRelsXml) {
      continue;
    }

    const rels = parseRelationships(slideRelsXml);
    const notesRel = rels.find(rel => /\/notesSlide$/i.test(rel.type));
    if (!notesRel) {
      continue;
    }

    const notesPath = resolveZipRelationshipTarget(slide.path, notesRel.target);
    const notesXml = await readZipText(zip, notesPath);
    const speaker = notesXml ? extractSpeakerFromNotesXml(notesXml) : "";
    if (speaker) {
      rawSpeakerMap.set(slide.rawIndex, speaker);
    }
  }

  const result: Record<string, string> = {};
  let previousVisibleSpeaker = "";
  for (const slide of slideInfos) {
    if (slide.hidden || !slide.visibleIndex) {
      continue;
    }

    const speaker = rawSpeakerMap.get(slide.rawIndex) || "";
    if (!speaker) {
      continue;
    }

    if (!previousVisibleSpeaker || speakerKey(speaker) !== speakerKey(previousVisibleSpeaker)) {
      result[String(slide.visibleIndex)] = speaker;
      previousVisibleSpeaker = speaker;
    }
  }

  return result;
}

function buildSpeakersFromSlideSpeakers(slideSpeakers: Record<string, string>): any[] {
  const speakers: any[] = [];
  for (const ref of Object.values(slideSpeakers)) {
    const value = String(ref || "").trim();
    if (!value || isHostSpeakerReference(value) || speakers.some(speaker => matchesSpeaker(speaker, value))) {
      continue;
    }

    speakers.push(normalizeEditSpeaker({
      Name: value,
      Initials: looksLikeInitials(value) ? value : generateInitials(value),
      ColorHex: pickSpeakerColor(speakers.length)
    }, speakers.length));
  }

  return speakers;
}

function extractSpeakerFromNotesXml(notesXml: string): string {
  const doc = parseXml(notesXml);
  const paragraphs = descendantsByLocalName(doc, "p")
    .map(paragraph => descendantsByLocalName(paragraph, "t").map(text => text.textContent || "").join("").trim())
    .filter(text => !!text);
  const firstLine = paragraphs[0] || "";
  return firstLine.toUpperCase().startsWith("SPEAKER:")
    ? firstLine.slice("SPEAKER:".length).trim()
    : "";
}

function parseXml(xml: string): Document {
  return new DOMParser().parseFromString(xml, "application/xml");
}

function descendantsByLocalName(root: Document | Element, localName: string): Element[] {
  return Array.from(root.getElementsByTagName("*")).filter(element => element.localName === localName);
}

function getAttributeByLocalName(element: Element, localName: string, namespaceUri = ""): string {
  if (namespaceUri) {
    return element.getAttributeNS(namespaceUri, localName) || "";
  }

  for (const attribute of Array.from(element.attributes)) {
    if (attribute.localName === localName) {
      return attribute.value;
    }
  }

  return "";
}

function parseRelationshipMap(xml: string, sourcePath: string): Map<string, string> {
  const map = new Map<string, string>();
  for (const rel of parseRelationships(xml)) {
    map.set(rel.id, resolveZipRelationshipTarget(sourcePath, rel.target));
  }

  return map;
}

function parseRelationships(xml: string): Array<{ id: string; type: string; target: string }> {
  const doc = parseXml(xml);
  return descendantsByLocalName(doc, "Relationship").map(element => ({
    id: getAttributeByLocalName(element, "Id"),
    type: getAttributeByLocalName(element, "Type"),
    target: getAttributeByLocalName(element, "Target")
  }));
}

function getRelationshipsPath(partPath: string): string {
  const parts = partPath.split("/");
  const fileName = parts.pop() || "";
  return `${parts.join("/")}/_rels/${fileName}.rels`;
}

function resolveZipRelationshipTarget(sourcePath: string, target: string): string {
  if (!target) {
    return "";
  }

  if (target.startsWith("/")) {
    return target.replace(/^\/+/, "");
  }

  const stack = sourcePath.split("/");
  stack.pop();
  for (const part of target.split("/")) {
    if (!part || part === ".") {
      continue;
    }

    if (part === "..") {
      stack.pop();
    } else {
      stack.push(part);
    }
  }

  return stack.join("/");
}

function isHiddenPowerPointSlide(slideDoc: Document): boolean {
  const root = slideDoc.documentElement;
  const show = root?.getAttribute("show") || "";
  return show === "0" || show.toLowerCase() === "false";
}

function getOrCreateEmbeddedPresentation(): any {
  if (embeddedPresentation) {
    return embeddedPresentation;
  }

  const title = getCurrentPresentationTitle();
  embeddedPresentation = {
    Name: title,
    Title: title,
    PowerPointPath: currentDeckUrl || "",
    TotalAvailableMinutes: 0,
    ScheduledStartTime: "",
    DelayedStartSlideIndex: 1,
    StartOffsetMinutes: 0,
    Sections: [],
    Breaks: [],
    Sessions: [],
    Speakers: [],
    SlideSpeakers: {},
    SlideCallouts: {},
    SlideMaximumSeconds: {},
    SlideMaximumSecondsBySlideId: {},
    SlideAnimationStepCounts: {}
  };
  return embeddedPresentation;
}

function getCurrentPresentationTitle(): string {
  const fileName = currentDeckFileName || "";
  const withoutExtension = fileName.replace(/\.[^.]+$/, "").trim();
  return withoutExtension || fileName || "PowerPoint presentation";
}

function getCurrentSectionName(slideIndex: number): string {
  const section = findSectionForSlide(slideIndex);
  return section?.Name || section?.name || "";
}

function findSectionForSlide(slideIndex: number): any {
  const sections = getPresentationSections();
  let start = 1;
  for (const section of sections) {
    const slideCount = Math.max(1, toPositiveNumber(section.Slides ?? section.slides ?? 1));
    const end = start + slideCount - 1;
    if (slideIndex >= start && slideIndex <= end) {
      return section;
    }
    start = end + 1;
  }

  return null;
}

function getPresentationSections(): any[] {
  const model = getOrCreateEmbeddedPresentation();
  const sections = model.Sections || model.sections;
  if (Array.isArray(sections)) {
    return sections;
  }

  model.Sections = [];
  return model.Sections;
}

function getEmbeddedSpeakers(): SharedSpeaker[] {
  const speakers = readEmbeddedPresentationValue("Speakers") || readEmbeddedPresentationValue("speakers");
  return Array.isArray(speakers) ? speakers : [];
}

function speakerForEmbeddedSlide(slideIndex: number): SharedSpeaker | null {
  if (!embeddedPresentation) {
    return null;
  }

  const slideSpeakers = readEmbeddedPresentationValue("SlideSpeakers") || readEmbeddedPresentationValue("slideSpeakers");
  if (!slideSpeakers || editSpeakers.length === 0) {
    return null;
  }

  let speakerRef = "";
  let bestSlide = -1;
  let firstSlide = Number.MAX_SAFE_INTEGER;
  for (const key of Object.keys(slideSpeakers)) {
    const slide = Number.parseInt(key, 10);
    if (!Number.isFinite(slide)) {
      continue;
    }

    const value = String(slideSpeakers[key] || "");
    if (slide < firstSlide) {
      firstSlide = slide;
      if (!speakerRef) {
        speakerRef = value;
      }
    }

    if (slide <= slideIndex && slide > bestSlide) {
      bestSlide = slide;
      speakerRef = value;
    }
  }

  return speakerRef
    ? editSpeakers.find(speaker => matchesSpeaker(speaker, speakerRef)) || null
    : null;
}

function renderSpeakerPicker(selectedSpeaker: SharedSpeaker | null): void {
  elements.speakerPickerValue.replaceChildren(createSpeakerOptionContent(selectedSpeaker, "No speakers found"));
  elements.speakerPickerList.replaceChildren();

  editSpeakers.forEach((speaker, index) => {
    const option = document.createElement("button");
    option.type = "button";
    option.className = "speaker-option";
    option.id = `speakerOption${index}`;
    option.setAttribute("role", "option");
    option.setAttribute("aria-selected", selectedSpeaker && speakersMatch(speaker, selectedSpeaker) ? "true" : "false");
    option.appendChild(createSpeakerOptionContent(speaker, "Speaker"));
    option.addEventListener("click", event => {
      event.stopPropagation();
      void selectEditSpeaker(speaker);
    });
    elements.speakerPickerList.appendChild(option);
  });

  if (editFocusedSpeakerIndex < 0 || editFocusedSpeakerIndex >= editSpeakers.length) {
    editFocusedSpeakerIndex = Math.max(0, editSpeakers.findIndex(speaker =>
      selectedSpeaker && speakersMatch(speaker, selectedSpeaker)));
  }
  updateSpeakerOptionFocus();
}

function createSpeakerOptionContent(speaker: SharedSpeaker | null, fallback: string): HTMLElement {
  const root = document.createElement("span");
  root.className = "speaker-option-content";
  root.appendChild(createSpeakerAvatar(speaker));

  const name = document.createElement("span");
  name.className = "speaker-name";
  name.textContent = speaker ? speakerDisplayNameForPicker(speaker) : fallback;
  root.appendChild(name);
  return root;
}

function createSpeakerAvatar(speaker: SharedSpeaker | null): HTMLElement {
  const avatar = document.createElement("span");
  avatar.className = "speaker-avatar";
  const speakerColor = normalizeSpeakerColor(getSpeakerValue(speaker, "colorHex"));
  avatar.style.backgroundColor = speakerColor;
  avatar.style.borderColor = speakerColor;

  const avatarDataUrl = getSpeakerValue(speaker, "avatarDataUrl");
  if (avatarDataUrl) {
    const image = document.createElement("img");
    image.src = avatarDataUrl;
    image.alt = "";
    avatar.appendChild(image);
    return avatar;
  }

  avatar.textContent = getSpeakerValue(speaker, "initials") || speakerDisplayNameForPicker(speaker).slice(0, 2).toUpperCase();
  return avatar;
}

function normalizeSpeakerColor(value: string): string {
  return /^#[0-9a-f]{6}$/i.test(value) ? value : "#1E88E5";
}

function toggleSpeakerPicker(): void {
  if (editSpeakerListOpen) {
    closeSpeakerPicker();
  } else {
    openSpeakerPicker();
  }
}

function openSpeakerPicker(): void {
  if (elements.speakerPickerButton.disabled || editSpeakers.length === 0) {
    return;
  }

  editSpeakerListOpen = true;
  elements.speakerPickerButton.setAttribute("aria-expanded", "true");
  elements.speakerPickerList.hidden = false;
  updateSpeakerOptionFocus();
}

function closeSpeakerPicker(): void {
  editSpeakerListOpen = false;
  elements.speakerPickerButton.setAttribute("aria-expanded", "false");
  elements.speakerPickerList.hidden = true;
}

function handleSpeakerPickerButtonKeyDown(event: KeyboardEvent): void {
  if (event.key === "ArrowDown" || event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    openSpeakerPicker();
    focusSpeakerOption(editFocusedSpeakerIndex >= 0 ? editFocusedSpeakerIndex : 0);
  }
}

function handleSpeakerPickerListKeyDown(event: KeyboardEvent): void {
  if (!editSpeakerListOpen) {
    return;
  }

  if (event.key === "Escape") {
    event.preventDefault();
    closeSpeakerPicker();
    elements.speakerPickerButton.focus();
    return;
  }

  if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Home" || event.key === "End") {
    event.preventDefault();
    const lastIndex = editSpeakers.length - 1;
    const nextIndex = event.key === "Home"
      ? 0
      : event.key === "End"
        ? lastIndex
        : Math.max(0, Math.min(lastIndex, editFocusedSpeakerIndex + (event.key === "ArrowDown" ? 1 : -1)));
    focusSpeakerOption(nextIndex);
    return;
  }

  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    const speaker = editSpeakers[editFocusedSpeakerIndex];
    if (speaker) {
      void selectEditSpeaker(speaker);
    }
  }
}

function focusSpeakerOption(index: number): void {
  editFocusedSpeakerIndex = Math.max(0, Math.min(editSpeakers.length - 1, index));
  updateSpeakerOptionFocus();
  const option = elements.speakerPickerList.querySelector<HTMLElement>(`#speakerOption${editFocusedSpeakerIndex}`);
  option?.focus();
}

function updateSpeakerOptionFocus(): void {
  elements.speakerPickerList.querySelectorAll<HTMLElement>(".speaker-option").forEach((option, index) => {
    option.classList.toggle("focused", index === editFocusedSpeakerIndex);
    option.tabIndex = index === editFocusedSpeakerIndex ? 0 : -1;
  });
}

async function selectEditSpeaker(speaker: SharedSpeaker): Promise<void> {
  closeSpeakerPicker();
  renderSpeakerPicker(speaker);
  elements.speakerPickerButton.focus();

  const target = await readCurrentSlideTarget();
  if (!target) {
    setEditStatus("Select a slide before changing its speaker.");
    return;
  }

  const speakerRef = getSpeakerValue(speaker, "initials") || getSpeakerValue(speaker, "name");
  if (!speakerRef) {
    setEditStatus("This speaker is missing a name or initials.");
    return;
  }

  applyEmbeddedSpeakerSelection(target.slideIndex, speakerRef);
  setEditStatus(`Updating slide ${target.slideIndex} speaker...`);
  try {
    await saveEmbeddedTimerMetadata();
    setEditStatus(`Slide ${target.slideIndex} speaker set to ${speakerDisplayNameForPicker(speaker)}.`);
  } catch (error) {
    setEditStatus(error instanceof Error ? error.message : "Timer metadata could not be saved.");
  }
}

function applyEmbeddedSpeakerSelection(slideIndex: number, speakerRef: string): void {
  getOrCreateEmbeddedPresentation();

  const slideSpeakers = readEmbeddedPresentationValue("SlideSpeakers") ||
    readEmbeddedPresentationValue("slideSpeakers") ||
    {};
  slideSpeakers[String(slideIndex)] = speakerRef;
  if ("SlideSpeakers" in embeddedPresentation || !("slideSpeakers" in embeddedPresentation)) {
    embeddedPresentation.SlideSpeakers = slideSpeakers;
  } else {
    embeddedPresentation.slideSpeakers = slideSpeakers;
  }
}

async function saveEmbeddedTimerMetadata(): Promise<void> {
  const model = getOrCreateEmbeddedPresentation();
  if (currentDeckUrl && !readPresentationProperty(model, "PowerPointPath")) {
    model.PowerPointPath = currentDeckUrl;
  }

  await mergeUneditedTimerMetadataFromLatest(model);

  const json = JSON.stringify(model);
  const xml = createTimerXml(json);
  await replaceTimerinatorCustomXml(xml);
  embeddedRemoteStartLoaded = false;
  embeddedMetadataLoaded = false;
  await loadEmbeddedRemoteStartInfo();
}

async function mergeUneditedTimerMetadataFromLatest(model: any): Promise<void> {
  let latest: any = null;
  try {
    const xml = await readTimerinatorCustomXml();
    const presentationJson = xml ? extractPresentationJson(xml) : "";
    latest = presentationJson ? normalizeEditModel(JSON.parse(presentationJson)) : null;
  } catch {
    latest = null;
  }

  if (!latest) {
    return;
  }

  preserveUneditedTimerField(
    model,
    latest,
    "StartTime",
    value => !normalizeTimeText(value));
  preserveUneditedTimerField(
    model,
    latest,
    "DelayedStartSlideIndex",
    value => toNonNegativeInteger(value, 1) <= 1);
  preserveUneditedTimerField(
    model,
    latest,
    "StartOffsetMinutes",
    value => toNonNegativeInteger(value, 0) <= 0);
  preserveUneditedTimerField(
    model,
    latest,
    "TotalAvailableMinutes",
    value => toNonNegativeInteger(value, 0) <= 0);
}

function preserveUneditedTimerField(
  model: any,
  latest: any,
  fieldName: string,
  isDefaultValue: (value: any) => boolean): void {
  if (editDirtyFields.has(fieldName) || !isDefaultValue(model?.[fieldName])) {
    return;
  }

  const latestValue = latest?.[fieldName];
  if (!isDefaultValue(latestValue)) {
    model[fieldName] = latestValue;
  }
}

function createTimerXml(presentationJson: string): string {
  const xmlDocument = document.implementation.createDocument(timerNamespaceUri, "timer");
  xmlDocument.documentElement.setAttribute("version", "1");
  const jsonElement = xmlDocument.createElementNS(timerNamespaceUri, "presentationJson");
  jsonElement.textContent = presentationJson;
  xmlDocument.documentElement.appendChild(jsonElement);
  return new XMLSerializer().serializeToString(xmlDocument);
}

async function replaceTimerinatorCustomXml(xml: string): Promise<void> {
  if (canUsePowerPointCustomXmlParts()) {
    try {
      await replacePowerPointCustomXml(xml);
      return;
    } catch (error) {
      addDiagnostic(`PowerPoint custom XML save failed: ${error instanceof Error ? error.message : "unknown error"}.`);
    }
  }

  const customXmlParts = Office.context?.document?.customXmlParts;
  if (!customXmlParts?.addAsync) {
    throw new Error("This PowerPoint host cannot save timer metadata. Update PowerPoint to a version that supports custom XML parts.");
  }

  const existing = await getTimerinatorCustomXmlParts();
  for (const part of existing) {
    await deleteCustomXmlPart(part);
  }

  await addCustomXmlPart(xml);
}

function canUsePowerPointCustomXmlParts(): boolean {
  return typeof PowerPoint !== "undefined" && typeof PowerPoint.run === "function";
}

async function replacePowerPointCustomXml(xml: string): Promise<void> {
  await PowerPoint.run(async (context: any) => {
    const customXmlParts = context?.presentation?.customXmlParts;
    if (!customXmlParts?.getByNamespace || !customXmlParts?.add) {
      throw new Error("PowerPoint custom XML parts are unavailable.");
    }

    const existing = customXmlParts.getByNamespace(timerNamespaceUri);
    existing.load("items");
    await context.sync();

    for (const part of existing.items || []) {
      part.delete();
    }

    customXmlParts.add(xml);
    await context.sync();
  });
}

function getTimerinatorCustomXmlParts(): Promise<any[]> {
  const customXmlParts = Office.context?.document?.customXmlParts;
  if (!customXmlParts?.getByNamespaceAsync) {
    return Promise.resolve([]);
  }

  return new Promise(resolve => {
    customXmlParts.getByNamespaceAsync(timerNamespaceUri, (result: any) => {
      resolve(result?.status === Office.AsyncResultStatus.Succeeded && Array.isArray(result.value)
        ? result.value
        : []);
    });
  });
}

function deleteCustomXmlPart(part: any): Promise<void> {
  if (!part?.deleteAsync) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    part.deleteAsync((result: any) => {
      if (result?.status === Office.AsyncResultStatus.Succeeded) {
        resolve();
      } else {
        reject(new Error(result?.error?.message || "Timer metadata could not be replaced."));
      }
    });
  });
}

function addCustomXmlPart(xml: string): Promise<void> {
  return new Promise((resolve, reject) => {
    Office.context.document.customXmlParts.addAsync(xml, (result: any) => {
      if (result?.status === Office.AsyncResultStatus.Succeeded) {
        resolve();
      } else {
        reject(new Error(result?.error?.message || "Timer metadata could not be saved."));
      }
    });
  });
}

function readCodeFromQuery(): boolean {
  const query = new URLSearchParams(window.location.search);
  const code = query.get("code");
  if (code) {
    showView("connect");
    elements.shareCodeInput.value = code;
    connectToSharedTimer();
    return true;
  }

  return false;
}

function loadDocumentIdentity(): Promise<void> {
  return new Promise(resolve => {
    Office.context.document.getFilePropertiesAsync((result: any) => {
      if (result?.status === Office.AsyncResultStatus.Succeeded) {
        currentDeckUrl = result.value?.url || "";
        currentDeckFileName = getFileNameFromUrl(currentDeckUrl);
        addDiagnostic(`Document identity: ${currentDeckFileName || currentDeckUrl || "available"}.`);
      }
      resolve();
    });
  });
}

async function loadEmbeddedRemoteStartInfo(): Promise<void> {
  if (embeddedRemoteStartLoaded && embeddedMetadataLoaded) {
    return;
  }

  embeddedRemoteStartLoaded = true;
  try {
    const xml = await readTimerinatorCustomXml();
    if (!xml) {
      return;
    }

    const presentationJson = extractPresentationJson(xml);
    if (!presentationJson) {
      return;
    }

    embeddedPresentation = JSON.parse(presentationJson);
    const sessionCode = normalizeCode(readPresentationProperty(embeddedPresentation, "RemoteStartSessionCode"));
    const participantCode = normalizeCode(readPresentationProperty(embeddedPresentation, "RemoteStartParticipantCode"));
    const mainPresenterCode = normalizeCode(readPresentationProperty(embeddedPresentation, "RemoteStartPresenterCode"));
    if (mainPresenterCode) {
      embeddedRemoteStartInfo = {
        sessionCode,
        participantCode,
        mainPresenterCode
      };
      addDiagnostic(`Embedded remote-start metadata loaded for session ${sessionCode || "(new)"}.`);
    }
  } catch {
    addDiagnostic("Embedded remote-start metadata could not be parsed.");
  } finally {
    embeddedMetadataLoaded = true;
  }
}

function readTimerinatorCustomXml(): Promise<string | null> {
  if (canUsePowerPointCustomXmlParts()) {
    return readPowerPointCustomXml().catch(error => {
      addDiagnostic(`PowerPoint custom XML read failed: ${error instanceof Error ? error.message : "unknown error"}.`);
      return readOfficeCustomXml();
    });
  }

  return readOfficeCustomXml();
}

function readOfficeCustomXml(): Promise<string | null> {
  const customXmlParts = Office.context?.document?.customXmlParts;
  if (!customXmlParts?.getByNamespaceAsync) {
    return Promise.resolve(null);
  }

  return new Promise(resolve => {
    customXmlParts.getByNamespaceAsync(timerNamespaceUri, (result: any) => {
      if (result?.status !== Office.AsyncResultStatus.Succeeded || !Array.isArray(result.value) || result.value.length === 0) {
        resolve(null);
        return;
      }

      void readFirstXmlPart(result.value).then(resolve);
    });
  });
}

async function readPowerPointCustomXml(): Promise<string | null> {
  let xml: string | null = null;
  await PowerPoint.run(async (context: any) => {
    const customXmlParts = context?.presentation?.customXmlParts;
    if (!customXmlParts?.getByNamespace) {
      throw new Error("PowerPoint custom XML parts are unavailable.");
    }

    const scopedParts = customXmlParts.getByNamespace(timerNamespaceUri);
    scopedParts.load("items");
    await context.sync();

    for (const part of scopedParts.items || []) {
      const xmlResult = part.getXml();
      await context.sync();
      const candidate = String(xmlResult.value || "");
      if (candidate && extractPresentationJson(candidate)) {
        xml = candidate;
        return;
      }
    }
  });

  return xml;
}

async function readFirstXmlPart(parts: any[]): Promise<string | null> {
  for (const part of parts) {
    const xml = await readXmlPart(part);
    if (xml && extractPresentationJson(xml)) {
      return xml;
    }
  }

  return null;
}

function readXmlPart(part: any): Promise<string | null> {
  if (!part?.getXmlAsync) {
    return Promise.resolve(null);
  }

  return new Promise(resolve => {
    part.getXmlAsync((result: any) => {
      resolve(result?.status === Office.AsyncResultStatus.Succeeded ? String(result.value || "") : null);
    });
  });
}

function extractPresentationJson(xml: string): string {
  const document = new DOMParser().parseFromString(xml, "application/xml");
  const namespaced = document.getElementsByTagNameNS(timerNamespaceUri, "presentationJson")[0];
  const fallback = document.getElementsByTagName("presentationJson")[0];
  return (namespaced || fallback)?.textContent || "";
}

function readPresentationProperty(presentationJson: any, name: string): string {
  const lowerCamel = name[0].toLowerCase() + name.slice(1);
  return String(presentationJson?.[name] || presentationJson?.[lowerCamel] || "");
}

function getEmbeddedMainPresenterCode(sessionCode: string): string {
  if (!embeddedRemoteStartInfo?.mainPresenterCode) {
    return "";
  }

  const embeddedSessionCode = normalizeCode(embeddedRemoteStartInfo.sessionCode);
  const requestedSessionCode = normalizeCode(sessionCode);
  if (embeddedSessionCode && requestedSessionCode && embeddedSessionCode !== requestedSessionCode) {
    return "";
  }

  return embeddedRemoteStartInfo.mainPresenterCode;
}

function wireConnectionHandlers(nextConnection: HubConnection): void {
  nextConnection.on("ReceivePresentation", json => {
    addDiagnostic(`Received presentation payload (${String(json || "").length} chars).`);
    try {
      presentation = JSON.parse(json);
    } catch {
      presentation = null;
    }
    updateView();
  });
  nextConnection.on("ReceiveStatus", status => {
    timerStatus = normalizeKeys(status);
    isSessionWaiting = false;
    addDiagnostic(`Received status: ${timerStatus?.timerState || "unknown"}.`);
    updateView();
    maybeSyncCurrentSlide();
  });
  nextConnection.on("ReceiveSessionWaiting", info => {
    const waiting = normalizeKeys(info);
    isSessionWaiting = true;
    isMainPresenter = !!waiting?.isMainPresenter;
    if (waiting?.trustedSpeaker) {
      trustedSpeaker = waiting.trustedSpeaker;
      isTrustedSpeaker = true;
    }
    timerStatus = null;
    addDiagnostic(`Received waiting state. Main presenter: ${isMainPresenter ? "yes" : "no"}.`);
    updateView();
  });
  nextConnection.on("ReceiveSessionStarted", () => {
    void handleSessionStarted();
  });
  nextConnection.on("ReceiveSlideNavigation", message => {
    void handleRemoteSlideNavigation(normalizeKeys(message));
  });
  nextConnection.on("ReceiveSlideSync", message => {
    void handleRemoteSlideSync(normalizeKeys(message));
  });
  nextConnection.on("SpeakerPresenceChanged", (speakerId, connected) => {
    updateShareSpeakerPresence(String(speakerId || ""), !!connected);
  });
  nextConnection.on("SessionEnded", () => {
    elements.connectStatus.textContent = "The shared timer ended.";
    elements.shareStatus.textContent = "The shared timer ended.";
    addDiagnostic("Received session ended.");
    disconnect(false);
  });
}

async function shareCurrentPresentation(): Promise<void> {
  await loadEmbeddedRemoteStartInfo();
  renderShareSpeakers();
  const selectedSpeaker = getSelectedShareSpeaker();
  const presentationJson = JSON.stringify(getOrCreateEmbeddedPresentation());
  await disconnect(false);
  elements.startSharingButton.disabled = true;
  elements.startSharingButton.textContent = "Starting...";
  elements.shareStatus.textContent = "Starting sharing...";
  setShareSpeakerListDisabled(true);

  try {
    const nextConnection: HubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${getServiceOrigin().replace(/\/$/, "")}/presentationHub`)
      .withAutomaticReconnect()
      .build();
    connection = nextConnection;
    activeHubOrigin = getServiceOrigin();
    wireConnectionHandlers(nextConnection);
    await nextConnection.start();

    const created = normalizeKeys(await nextConnection.invoke<ShareSessionCreated>(
      "StartPowerPointSession",
      presentationJson)) as ShareSessionCreated;

    activeShareResult = created;
    activeCode = created.mainPresenterCode || created.code || "";
    elements.shareCodeInput.value = activeCode;
    isMainPresenter = true;
    isTrustedSpeaker = true;
    isSessionWaiting = false;
    trustedSpeaker = selectedSpeaker;
    presentation = getOrCreateEmbeddedPresentation();
    saveSelectedShareSpeaker(selectedShareSpeakerId);

    if (activeCode) {
      await nextConnection.invoke<boolean>("JoinSession", activeCode);
    }

    renderShareResult(created);
    elements.disconnectButton.hidden = false;
    elements.shareStatus.textContent = selectedSpeaker
      ? `Sharing as ${speakerDisplayNameForPicker(selectedSpeaker)}.`
      : "Sharing is active.";
    elements.connectStatus.textContent = "Connected as main presenter.";
    startPollingSlideSelection();
    updateView();
    maybeSyncCurrentSlide();
  } catch (error) {
    await disconnect(false);
    const message = error instanceof Error ? error.message : "Sharing could not start.";
    elements.shareStatus.textContent = message;
    addDiagnostic(`Share presentation failed: ${message}`);
  } finally {
    elements.startSharingButton.disabled = false;
    updateShareButtonState();
    renderShareSpeakers();
  }
}

async function stopSharingFromAddIn(): Promise<void> {
  await disconnect();
  activeShareResult = null;
  renderShareResult(null);
  elements.shareStatus.textContent = "Not sharing";
  updateShareButtonState();
  renderShareSpeakers();
}

function renderShareSpeakers(preserveInput = false): void {
  if (shareSpeakersLoading) {
    elements.shareSpeakerShimmer.hidden = false;
    elements.shareSpeakerPicker.hidden = true;
    elements.shareSpeakersEmptyState.hidden = true;
    elements.startSharingButton.disabled = true;
    return;
  }

  shareSpeakers = getPresentationSpeakersForSharing();
  if (!selectedShareSpeakerId || !shareSpeakers.some(speaker => getShareSpeakerId(speaker) === selectedShareSpeakerId)) {
    selectedShareSpeakerId = chooseDefaultShareSpeakerId(shareSpeakers);
  }

  const selectedSpeaker = getSelectedShareSpeaker();
  elements.shareSpeakerShimmer.hidden = true;
  elements.shareSpeakerPicker.hidden = false;
  elements.shareSpeakerList.replaceChildren();
  elements.shareSpeakersEmptyState.hidden = shareSpeakers.length > 0;
  elements.startSharingButton.disabled = false;
  elements.shareSpeakerPickerInput.disabled = shareSpeakers.length === 0 || !!activeShareResult;
  elements.shareSpeakerPickerButton.disabled = shareSpeakers.length === 0 || !!activeShareResult;
  elements.shareSpeakerPickerInput.setAttribute("aria-expanded", shareSpeakerListOpen ? "true" : "false");
  elements.shareSpeakerPickerButton.setAttribute("aria-expanded", shareSpeakerListOpen ? "true" : "false");

  elements.shareSpeakerPickerAvatar.replaceChildren();
  if (selectedSpeaker) {
    elements.shareSpeakerPickerAvatar.hidden = false;
    elements.shareSpeakerPickerAvatar.appendChild(createSpeakerAvatar(selectedSpeaker));
  } else {
    elements.shareSpeakerPickerAvatar.hidden = true;
  }

  if (!preserveInput || !shareSpeakerListOpen) {
    elements.shareSpeakerPickerInput.value = selectedSpeaker ? getShareSpeakerDisplayName(selectedSpeaker) : "";
    shareSpeakerFilter = "";
  }

  shareFilteredSpeakers = getFilteredShareSpeakers();
  if (shareFocusedSpeakerIndex < 0 || shareFocusedSpeakerIndex >= shareFilteredSpeakers.length) {
    shareFocusedSpeakerIndex = Math.max(0, shareFilteredSpeakers.findIndex(speaker => getShareSpeakerId(speaker) === selectedShareSpeakerId));
  }

  if (shareFilteredSpeakers.length === 0) {
    const empty = document.createElement("div");
    empty.className = "speaker-option share-speaker-option empty-state";
    empty.setAttribute("role", "option");
    empty.setAttribute("aria-disabled", "true");
    empty.textContent = "No matching co-presenters";
    elements.shareSpeakerList.appendChild(empty);
    return;
  }

  shareFilteredSpeakers.forEach((speaker, index) => {
    const speakerId = getShareSpeakerId(speaker);
    const selected = speakerId === selectedShareSpeakerId;
    const option = document.createElement("button");
    option.type = "button";
    option.className = "speaker-option share-speaker-option";
    option.dataset.speakerId = speakerId;
    option.id = `shareSpeakerOption${index}`;
    option.setAttribute("role", "option");
    option.setAttribute("aria-selected", selected ? "true" : "false");
    option.appendChild(createShareSpeakerOptionContent(speaker, "Co-presenter"));
    option.addEventListener("click", event => {
      event.stopPropagation();
      selectShareSpeaker(speakerId);
    });
    elements.shareSpeakerList.appendChild(option);
  });

  updateShareSpeakerOptionFocus();
}

function toggleShareSpeakerPicker(): void {
  if (shareSpeakerListOpen) {
    closeShareSpeakerPicker();
  } else {
    openShareSpeakerPicker();
  }
}

function openShareSpeakerPicker(): void {
  if (elements.shareSpeakerPickerButton.disabled || shareSpeakers.length === 0) {
    return;
  }

  shareSpeakerListOpen = true;
  elements.shareSpeakerPickerInput.setAttribute("aria-expanded", "true");
  elements.shareSpeakerPickerButton.setAttribute("aria-expanded", "true");
  elements.shareSpeakerList.hidden = false;
  renderShareSpeakers(true);
  updateShareSpeakerOptionFocus();
}

function closeShareSpeakerPicker(): void {
  shareSpeakerListOpen = false;
  elements.shareSpeakerPickerInput.setAttribute("aria-expanded", "false");
  elements.shareSpeakerPickerButton.setAttribute("aria-expanded", "false");
  elements.shareSpeakerList.hidden = true;
}

function handleShareSpeakerPickerInputKeyDown(event: KeyboardEvent): void {
  if (event.key === "ArrowDown") {
    event.preventDefault();
    openShareSpeakerPicker();
    focusShareSpeakerOption(shareFocusedSpeakerIndex >= 0 ? shareFocusedSpeakerIndex : 0);
    return;
  }

  if (event.key === "Enter") {
    if (shareSpeakerListOpen && shareFilteredSpeakers[shareFocusedSpeakerIndex]) {
      event.preventDefault();
      selectShareSpeaker(getShareSpeakerId(shareFilteredSpeakers[shareFocusedSpeakerIndex]));
    }
    return;
  }

  if (event.key === "Escape") {
    event.preventDefault();
    closeShareSpeakerPicker();
    renderShareSpeakers(false);
    return;
  }

  if (event.key === "Tab") {
    closeShareSpeakerPicker();
  }
}

function handleShareSpeakerListKeyDown(event: KeyboardEvent): void {
  if (!shareSpeakerListOpen) {
    return;
  }

  if (event.key === "Escape") {
    event.preventDefault();
    closeShareSpeakerPicker();
    elements.shareSpeakerPickerButton.focus();
    return;
  }

  if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Home" || event.key === "End") {
    event.preventDefault();
    const lastIndex = shareFilteredSpeakers.length - 1;
    const nextIndex = event.key === "Home"
      ? 0
      : event.key === "End"
        ? lastIndex
        : Math.max(0, Math.min(lastIndex, shareFocusedSpeakerIndex + (event.key === "ArrowDown" ? 1 : -1)));
    focusShareSpeakerOption(nextIndex);
    return;
  }

  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    const speaker = shareFilteredSpeakers[shareFocusedSpeakerIndex];
    if (speaker) {
      selectShareSpeaker(getShareSpeakerId(speaker));
    }
  }
}

function focusShareSpeakerOption(index: number): void {
  shareFocusedSpeakerIndex = Math.max(0, Math.min(shareFilteredSpeakers.length - 1, index));
  updateShareSpeakerOptionFocus();
  const option = elements.shareSpeakerList.querySelector<HTMLElement>(`#shareSpeakerOption${shareFocusedSpeakerIndex}`);
  option?.focus();
}

function updateShareSpeakerOptionFocus(): void {
  elements.shareSpeakerList.querySelectorAll<HTMLElement>(".share-speaker-option").forEach((option, index) => {
    option.classList.toggle("focused", index === shareFocusedSpeakerIndex);
    option.tabIndex = index === shareFocusedSpeakerIndex ? 0 : -1;
  });
}

function selectShareSpeaker(speakerId: string): void {
  if (!speakerId || activeShareResult) {
    return;
  }

  selectedShareSpeakerId = speakerId;
  saveSelectedShareSpeaker(speakerId);
  closeShareSpeakerPicker();
  shareSpeakerFilter = "";
  renderShareSpeakers();
  elements.shareSpeakerPickerInput.focus();
}

function getFilteredShareSpeakers(): SharedSpeaker[] {
  const filter = speakerKey(shareSpeakerFilter);
  if (!filter) {
    return shareSpeakers;
  }

  return shareSpeakers.filter(speaker => {
    const searchable = [
      getSpeakerValue(speaker, "name"),
      getSpeakerValue(speaker, "initials")
    ].map(value => speakerKey(value));
    return searchable.some(value => value.includes(filter));
  });
}

function getShareSpeakerDisplayName(speaker: Nullable<SharedSpeaker>): string {
  return getSpeakerValue(speaker, "name") || getSpeakerValue(speaker, "initials") || "";
}

function createShareSpeakerOptionContent(speaker: SharedSpeaker | null, fallback: string): HTMLElement {
  const root = document.createElement("span");
  root.className = "speaker-option-content";
  root.appendChild(createSpeakerAvatar(speaker));

  const name = document.createElement("span");
  name.className = "speaker-name";
  name.textContent = speaker ? getShareSpeakerDisplayName(speaker) : fallback;
  root.appendChild(name);
  return root;
}

function getPresentationSpeakersForSharing(): SharedSpeaker[] {
  const model = getOrCreateEmbeddedPresentation();
  return normalizeArray(model?.Speakers || model?.speakers)
    .map(normalizeShareSpeaker)
    .filter(speaker => !!(getSpeakerValue(speaker, "name") || getSpeakerValue(speaker, "initials")));
}

function normalizeShareSpeaker(speaker: any, index: number): SharedSpeaker {
  const name = String(speaker?.Name || speaker?.name || "").trim();
  const initials = String(speaker?.Initials || speaker?.initials || generateInitials(name)).trim();
  return {
    ...speaker,
    Id: String(speaker?.Id || speaker?.id || `speaker-${index + 1}`),
    Name: name || initials || `Speaker ${index + 1}`,
    Initials: initials || generateInitials(name),
    ColorHex: normalizeSpeakerColor(String(speaker?.ColorHex || speaker?.colorHex || pickSpeakerColor(index))),
    AvatarDataUrl: String(speaker?.AvatarDataUrl || speaker?.avatarDataUrl || "")
  };
}

function getShareSpeakerId(speaker: SharedSpeaker): string {
  return getSpeakerValue(speaker, "id") ||
    getSpeakerValue(speaker, "name") ||
    getSpeakerValue(speaker, "initials");
}

function getSelectedShareSpeaker(): SharedSpeaker | null {
  return shareSpeakers.find(speaker => getShareSpeakerId(speaker) === selectedShareSpeakerId) || null;
}

function chooseDefaultShareSpeakerId(speakers: SharedSpeaker[]): string {
  if (speakers.length === 0) {
    return "";
  }

  const saved = readSelectedShareSpeaker();
  if (saved && speakers.some(speaker => getShareSpeakerId(speaker) === saved)) {
    return saved;
  }

  const currentUserMatch = speakers.find(speaker => speakerMatchesCurrentOfficeUser(speaker));
  return getShareSpeakerId(currentUserMatch || speakers[0]);
}

function speakerMatchesCurrentOfficeUser(speaker: SharedSpeaker): boolean {
  const tokens = getOfficeUserTokens();
  if (tokens.length === 0) {
    return false;
  }

  const values = [
    getSpeakerValue(speaker, "id"),
    getSpeakerValue(speaker, "name"),
    getSpeakerValue(speaker, "initials")
  ].map(value => speakerKey(value)).filter(Boolean);

  return values.some(value => tokens.includes(value));
}

function getOfficeUserTokens(): string[] {
  const profile = Office.context?.userProfile || {};
  const values = [
    profile.displayName,
    profile.emailAddress,
    profile.email,
    profile.userName
  ].map(value => String(value || "").trim()).filter(Boolean);

  const tokens = new Set<string>();
  for (const value of values) {
    tokens.add(speakerKey(value));
    if (value.includes("@")) {
      tokens.add(speakerKey(value.split("@")[0].replace(/[._-]+/g, " ")));
    }
    tokens.add(speakerKey(generateInitials(value.includes("@") ? value.split("@")[0].replace(/[._-]+/g, " ") : value)));
  }

  return Array.from(tokens).filter(Boolean);
}

function readSelectedShareSpeaker(): string {
  try {
    return localStorage.getItem(getShareSpeakerPreferenceKey()) || "";
  } catch {
    return "";
  }
}

function saveSelectedShareSpeaker(speakerId: string): void {
  if (!speakerId) {
    return;
  }

  try {
    localStorage.setItem(getShareSpeakerPreferenceKey(), speakerId);
  } catch {
  }
}

function getShareSpeakerPreferenceKey(): string {
  const deckKey = (currentDeckUrl || currentDeckFileName || "presentation").trim().toLowerCase();
  return `${shareSpeakerPreferencePrefix}:${deckKey}`;
}

function setShareSpeakerListDisabled(disabled: boolean): void {
  if (disabled) {
    closeShareSpeakerPicker();
  }

  elements.shareSpeakerPickerButton.disabled = disabled || shareSpeakers.length === 0;
}

function updateShareButtonState(): void {
  const isSharing = !!connection && !!activeShareResult;
  elements.startSharingButton.textContent = isSharing ? "Stop sharing" : "Start sharing";
  elements.startSharingButton.classList.toggle("primary", !isSharing);
}

function updateShareSpeakerPresence(speakerId: string, connected: boolean): void {
  if (!activeShareResult?.speakerLinks?.length) {
    return;
  }

  let changed = false;
  for (const link of activeShareResult.speakerLinks) {
    if (speakerKey(getSpeakerValue(link, "id")) === speakerKey(speakerId)) {
      link.isConnected = connected;
      link.IsConnected = connected;
      changed = true;
    }
  }

  if (changed) {
    renderShareResult(activeShareResult);
  }
}

function renderShareResult(result: ShareSessionCreated | null): void {
  const hasResult = !!result;
  const speakerLinks = result?.speakerLinks || [];
  elements.shareResultPanel.hidden = !hasResult;
  elements.participantCodeOutput.value = result?.participantCode || "";
  elements.participantLinkOutput.value = result?.participantWebUrl || "";
  elements.mainPresenterLinkOutput.value = result?.mainPresenterWebUrl || result?.mainPresenterCode || "";
  elements.speakerLinksPanel.replaceChildren();
  elements.coPresenterLinksStatus.textContent = getCoPresenterLinksStatus(hasResult, speakerLinks.length);

  for (const link of speakerLinks) {
    const row = document.createElement("div");
    row.className = "speaker-link-row";

    const presenter = document.createElement("div");
    presenter.className = "presenter-cell";
    presenter.appendChild(createSpeakerAvatar(link));
    const name = document.createElement("span");
    name.textContent = speakerDisplayNameForPicker(link);
    presenter.appendChild(name);
    row.appendChild(presenter);

    const status = document.createElement("span");
    const isConnected = !!(link.isConnected ?? link.IsConnected);
    status.className = `connection-pill${isConnected ? " connected" : ""}`;
    status.textContent = isConnected ? "Connected" : "Not connected";
    row.appendChild(status);

    const code = document.createElement("button");
    code.type = "button";
    code.className = "code-chip";
    code.textContent = getSpeakerCodeValue(link) || "-";
    code.disabled = !getSpeakerCodeValue(link);
    code.setAttribute("aria-label", `Copy code for ${speakerDisplayNameForPicker(link)}`);
    code.addEventListener("click", () => copyText(getSpeakerCodeValue(link), `${speakerDisplayNameForPicker(link)} code copied.`));
    row.appendChild(code);

    const copyLink = document.createElement("button");
    copyLink.type = "button";
    copyLink.textContent = "Copy link";
    copyLink.disabled = !getSpeakerLinkValue(link);
    copyLink.setAttribute("aria-label", `Copy link for ${speakerDisplayNameForPicker(link)}`);
    copyLink.addEventListener("click", () => copyText(getSpeakerLinkValue(link), `${speakerDisplayNameForPicker(link)} link copied.`));
    row.appendChild(copyLink);

    elements.speakerLinksPanel.appendChild(row);
  }
}

function getCoPresenterLinksStatus(hasResult: boolean, count: number): string {
  if (!hasResult) {
    return "Co-presenter links appear after sharing starts.";
  }

  if (count === 0) {
    return "No co-presenters were found in this presentation.";
  }

  return count === 1
    ? "1 co-presenter link is available."
    : `${count} co-presenter links are available.`;
}

function getSpeakerLinkValue(link: SharedSpeakerLink): string {
  return String(link.webUrl || link.WebUrl || link.code || link.Code || "");
}

function getSpeakerCodeValue(link: SharedSpeakerLink): string {
  return String(link.code || link.Code || "");
}

async function copyOutputValue(output: HTMLInputElement, status: string): Promise<void> {
  const value = output.value.trim();
  await copyText(value, status);
}

async function copyText(value: string, status: string): Promise<void> {
  value = value.trim();
  if (!value) {
    return;
  }

  try {
    await navigator.clipboard.writeText(value);
  } catch {
    const output = document.createElement("input");
    output.value = value;
    output.style.position = "fixed";
    output.style.left = "-9999px";
    document.body.appendChild(output);
    output.select();
    document.execCommand("copy");
    output.remove();
  }

  elements.shareStatus.textContent = status;
}

async function connectToSharedTimer(): Promise<void> {
  await loadEmbeddedRemoteStartInfo();
  const target = parseShareTarget(elements.shareCodeInput.value);
  if (!target.code && embeddedRemoteStartInfo?.mainPresenterCode) {
    target.code = embeddedRemoteStartInfo.mainPresenterCode;
    target.origin = window.location.origin;
  } else if (!target.code) {
    elements.connectStatus.textContent = "Enter a share code or speaker link.";
    elements.shareCodeInput.focus();
    return;
  }

  await disconnect();
  activeCode = target.code;
  activeHubOrigin = target.origin || window.location.origin;
  elements.connectButton.disabled = true;
  elements.connectStatus.textContent = "Connecting...";
  addDiagnostic(`Command: connect to ${activeHubOrigin} with code ${maskCode(activeCode)}.`);

  try {
    const nextConnection: HubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${activeHubOrigin.replace(/\/$/, "")}/presentationHub`)
      .withAutomaticReconnect()
      .build();
    connection = nextConnection;

    nextConnection.on("ReceivePresentation", json => {
      addDiagnostic(`Received presentation payload (${String(json || "").length} chars).`);
      try {
        presentation = JSON.parse(json);
      } catch {
        presentation = null;
      }
      updateView();
    });
    nextConnection.on("ReceiveStatus", status => {
      timerStatus = normalizeKeys(status);
      isSessionWaiting = false;
      addDiagnostic(`Received status: ${timerStatus?.timerState || "unknown"}.`);
      updateView();
      maybeSyncCurrentSlide();
    });
    nextConnection.on("ReceiveSessionWaiting", info => {
      const waiting = normalizeKeys(info);
      isSessionWaiting = true;
      isMainPresenter = !!waiting?.isMainPresenter;
      if (waiting?.trustedSpeaker) {
        trustedSpeaker = waiting.trustedSpeaker;
        isTrustedSpeaker = true;
      }
      timerStatus = null;
      addDiagnostic(`Received waiting state. Main presenter: ${isMainPresenter ? "yes" : "no"}.`);
      updateView();
    });
    nextConnection.on("ReceiveSessionStarted", () => {
      void handleSessionStarted();
    });
    nextConnection.on("ReceiveSlideNavigation", message => {
      void handleRemoteSlideNavigation(normalizeKeys(message));
    });
    nextConnection.on("ReceiveSlideSync", message => {
      void handleRemoteSlideSync(normalizeKeys(message));
    });
    nextConnection.on("SessionEnded", () => {
      elements.connectStatus.textContent = "The shared timer ended.";
      addDiagnostic("Received session ended.");
      disconnect(false);
    });

    await nextConnection.start();
    addDiagnostic("SignalR connection started.");
    let access = normalizeKeys(await nextConnection.invoke<AccessInfo>("GetSessionAccess", activeCode));
    addDiagnostic(`GetSessionAccess: trusted=${!!access.isTrustedSpeaker}, main=${!!access.isMainPresenter}, waiting=${!!access.isWaiting}.`);
    const embeddedMainPresenterCode = getEmbeddedMainPresenterCode(access.sessionCode || activeCode);
    const shouldUseEmbeddedMainPresenterCode =
      embeddedMainPresenterCode &&
      normalizeCode(embeddedMainPresenterCode) !== activeCode &&
      !access.isTrustedSpeaker &&
      !access.isMainPresenter;
    if (shouldUseEmbeddedMainPresenterCode) {
      activeCode = embeddedMainPresenterCode;
      elements.shareCodeInput.value = activeCode;
      addDiagnostic("Using embedded main-presenter code for this deck.");
      access = normalizeKeys(await nextConnection.invoke<AccessInfo>("GetSessionAccess", activeCode));
      addDiagnostic(`GetSessionAccess after embedded code: trusted=${!!access.isTrustedSpeaker}, main=${!!access.isMainPresenter}, waiting=${!!access.isWaiting}.`);
    }

    isTrustedSpeaker = !!access.isTrustedSpeaker;
    isMainPresenter = !!access.isMainPresenter;
    isSessionWaiting = !!access.isWaiting;
    trustedSpeaker = access.speaker || null;
    const joined = await nextConnection.invoke<boolean>("JoinSession", activeCode);
    addDiagnostic(`JoinSession returned ${joined ? "true" : "false"}.`);
    if (!joined) {
      throw new Error("That share code is not active.");
    }

    elements.connectStatus.textContent = isMainPresenter
      ? "Connected as main presenter."
      : isTrustedSpeaker
      ? `Connected as ${speakerDisplayName(trustedSpeaker)}.`
      : "Connected as viewer.";
    elements.disconnectButton.hidden = false;
    startPollingSlideSelection();
    updateView();
  } catch (error) {
    await disconnect(false);
    elements.connectStatus.textContent = error instanceof Error ? error.message : "Could not connect.";
    addDiagnostic(`Connect failed: ${elements.connectStatus.textContent}`);
  } finally {
    elements.connectButton.disabled = false;
  }
}

async function handleSessionStarted(): Promise<void> {
  isSessionWaiting = false;
  addDiagnostic("Received session started.");

  if (connection && activeCode) {
    try {
      const joined = await connection.invoke<boolean>("JoinSession", activeCode);
      addDiagnostic(`JoinSession after session start returned ${joined ? "true" : "false"}.`);
      const access = normalizeKeys(await connection.invoke<AccessInfo>("GetSessionAccess", activeCode));
      isTrustedSpeaker = !!access.isTrustedSpeaker;
      isMainPresenter = !!access.isMainPresenter;
      trustedSpeaker = access.speaker || trustedSpeaker;
      addDiagnostic(`GetSessionAccess after session start: trusted=${!!access.isTrustedSpeaker}, main=${!!access.isMainPresenter}.`);
    } catch (error) {
      addDiagnostic(`Session-start join failed: ${error instanceof Error ? error.message : "unknown error"}.`);
    }
  }

  updateView();
}

async function disconnect(updateStatus = true): Promise<void> {
  if (pollHandle) {
    window.clearInterval(pollHandle);
    pollHandle = 0;
  }

  const existing = connection;
  connection = null;
  activeCode = "";
  activeHubOrigin = "";
  isTrustedSpeaker = false;
  isMainPresenter = false;
  isSessionWaiting = false;
  trustedSpeaker = null;
  presentation = null;
  timerStatus = null;
  lastSyncedTarget = "";
  activeShareResult = null;
  renderShareResult(null);
  elements.disconnectButton.hidden = true;
  elements.timerSection.hidden = true;
  elements.controlBadge.textContent = "Viewing";
  elements.controlBadge.classList.remove("control");
  if (updateStatus) {
    elements.connectStatus.textContent = "Not connected";
    elements.shareStatus.textContent = "Not sharing";
  }
  updateShareButtonState();
  renderShareSpeakers();

  if (existing) {
    try {
      await existing.stop();
      addDiagnostic("SignalR connection stopped.");
    } catch {
    }
  }
}

function registerOfficeSlideEvents(): void {
  const documentApi = Office.context?.document;
  if (!documentApi?.addHandlerAsync) {
    return;
  }

  const events = [
    Office.EventType?.DocumentSelectionChanged,
    Office.EventType?.ActiveViewChanged
  ].filter(Boolean);

  for (const eventType of events) {
    documentApi.addHandlerAsync(eventType, () => {
      maybeSyncCurrentSlide();
      void updateEditView();
    });
  }
}

function startPollingSlideSelection(): void {
  if (pollHandle) {
    window.clearInterval(pollHandle);
  }

  pollHandle = window.setInterval(() => maybeSyncCurrentSlide(), 1500);
}

function maybeSyncCurrentSlide(): void {
  if (!connection || !activeCode || !canControlSlides()) {
    updateView();
    return;
  }

  readCurrentSlideTarget().then(target => {
    if (!target || !canControlSlides() || !connection) {
      updateView();
      return;
    }

    const signature = `${target.slideId}:${target.slideIndex}:${activeCode}`;
    if (signature === lastSyncedTarget) {
      updateView();
      return;
    }

    lastSyncedTarget = signature;
    connection.invoke("SendSlideSync", activeCode, {
      slideId: target.slideId,
      slideIndex: target.slideIndex,
      speakerName: speakerDisplayName(trustedSpeaker),
      hostSpeakerId: getSpeakerValue(trustedSpeaker, "id") || null,
      powerPointFileName: currentDeckFileName || timerStatus?.powerPointFileName || null,
      deckIdentity: currentDeckUrl || currentDeckFileName || null
    }).then(() => {
      elements.slideStatus.textContent = "Slide sync is on.";
      addDiagnostic(`Command: SendSlideSync slideId=${target.slideId || "n/a"}, slideIndex=${target.slideIndex || "n/a"}.`);
    }).catch(error => {
      elements.slideStatus.textContent = error instanceof Error ? error.message : "Slide sync failed.";
      addDiagnostic(`SendSlideSync failed: ${elements.slideStatus.textContent}`);
    });
  });
}

async function handleRemoteSlideNavigation(message: SlideNavigationMessage): Promise<void> {
  if (!isMainPresenter) {
    return;
  }

  const direction = (message?.direction || 1) < 0 ? -1 : 1;
  addDiagnostic(`Received slide navigation from ${message?.speakerName || "co-presenter"}: ${direction < 0 ? "previous" : "next"}.`);
  const moved = await navigateLocalPowerPoint(direction);
  elements.slideStatus.textContent = moved
    ? "PowerPoint moved from co-presenter command."
    : "Co-presenter slide command received.";
  window.setTimeout(() => maybeSyncCurrentSlide(), moved ? 250 : 0);
}

async function handleRemoteSlideSync(message: SlideSyncMessage): Promise<void> {
  if (!isMainPresenter) {
    return;
  }

  const slideId = toPositiveNumber(message?.slideId);
  const slideIndex = toPositiveNumber(message?.slideIndex);
  addDiagnostic(`Received slide sync from ${message?.speakerName || "co-presenter"}: slideId=${slideId || "n/a"}, slideIndex=${slideIndex || "n/a"}.`);
  const moved = await navigateLocalPowerPointTarget(slideId, slideIndex);
  elements.slideStatus.textContent = moved
    ? "PowerPoint moved from co-presenter sync."
    : "Co-presenter slide sync received.";
  window.setTimeout(() => maybeSyncCurrentSlide(), moved ? 250 : 0);
}

function readCurrentSlideTarget(): Promise<SlideTarget | null> {
  return new Promise(resolve => {
    const coercionType = Office.CoercionType?.SlideRange;
    if (!coercionType || !Office.context?.document?.getSelectedDataAsync) {
      resolve(null);
      return;
    }

    Office.context.document.getSelectedDataAsync(coercionType, (result: any) => {
      if (result?.status !== Office.AsyncResultStatus.Succeeded) {
        resolve(null);
        return;
      }

      const slide = result.value?.slides?.[0] || result.value?.[0] || result.value;
      const slideId = toPositiveNumber(slide?.id ?? slide?.slideId);
      const slideIndex = toPositiveNumber(slide?.index ?? slide?.slideIndex);
      resolve(slideId || slideIndex ? { slideId, slideIndex } : null);
    });
  });
}

function navigateLocalPowerPoint(direction: number): Promise<boolean> {
  const documentApi = Office.context?.document;
  const goToType = Office.GoToType?.Index;
  const targetIndex = direction < 0 ? Office.Index?.Previous : Office.Index?.Next;
  if (!documentApi?.goToByIdAsync || !goToType || targetIndex === undefined || targetIndex === null) {
    return Promise.resolve(false);
  }

  return new Promise(resolve => {
    const options = Office.SelectionMode?.None
      ? { selectionMode: Office.SelectionMode.None }
      : {};
    documentApi.goToByIdAsync(targetIndex, goToType, options, (result: any) => {
      const succeeded = result?.status === Office.AsyncResultStatus.Succeeded;
      addDiagnostic(succeeded
        ? `Command: PowerPoint ${direction < 0 ? "previous" : "next"} slide.`
        : `PowerPoint navigation failed: ${result?.error?.message || "Unavailable"}.`);
      resolve(succeeded);
    });
  });
}

function navigateLocalPowerPointTarget(slideId: number, slideIndex: number): Promise<boolean> {
  const documentApi = Office.context?.document;
  const goToType = Office.GoToType?.Index;
  const target = slideIndex || slideId;
  if (!documentApi?.goToByIdAsync || !goToType || !target) {
    return Promise.resolve(false);
  }

  return new Promise(resolve => {
    const options = Office.SelectionMode?.None
      ? { selectionMode: Office.SelectionMode.None }
      : {};
    documentApi.goToByIdAsync(target, goToType, options, (result: any) => {
      const succeeded = result?.status === Office.AsyncResultStatus.Succeeded;
      addDiagnostic(succeeded
        ? `Command: PowerPoint go to slide ${target}.`
        : `PowerPoint slide sync failed: ${result?.error?.message || "Unavailable"}.`);
      resolve(succeeded);
    });
  });
}

async function startRemoteSession(): Promise<void> {
  if (!connection || !activeCode || !isMainPresenter) {
    updateView();
    return;
  }

  try {
    addDiagnostic("Command: StartRemoteSession.");
    const result = normalizeKeys(await connection.invoke<RemoteStartResult>("StartRemoteSession", activeCode));
    isSessionWaiting = false;
    elements.connectStatus.textContent = "Remote timer started.";
    addDiagnostic(`StartRemoteSession returned ${result?.started ? "started" : "not started"} for session ${maskCode(result?.sessionCode || "")}.`);
    updateView();
    maybeSyncCurrentSlide();
  } catch (error) {
    elements.slideStatus.textContent = error instanceof Error ? error.message : "Remote start failed.";
    addDiagnostic(`StartRemoteSession failed: ${elements.slideStatus.textContent}`);
  }
}

function canControlSlides(): boolean {
  if (isSessionWaiting) {
    return false;
  }

  if (isMainPresenter) {
    return true;
  }

  if (!isTrustedSpeaker || !timerStatus?.isPptSlideShowActive) {
    return false;
  }

  if (!toPositiveNumber(timerStatus.currentSlideIndexInPresentation)) {
    return false;
  }

  const activeControlSpeakerId = speakerKey(timerStatus.activeControlSpeakerId);
  const myId = speakerKey(getSpeakerValue(trustedSpeaker, "id"));
  if (activeControlSpeakerId && myId) {
    return activeControlSpeakerId === myId;
  }

  const currentSpeaker = speakerForSlide(timerStatus.currentSlideIndexInPresentation || 1);
  return isMe(currentSpeaker);
}

function speakerForSlide(slideIndex: number): SharedSpeaker | null {
  const slideSpeakers = getPresentationValue("slideSpeakers") || getPresentationValue("SlideSpeakers");
  const speakers = getPresentationValue("speakers") || getPresentationValue("Speakers");
  if (!slideSpeakers || !speakers) {
    return null;
  }

  let speakerRef = "";
  let bestSlide = -1;
  let firstSlide = Number.MAX_SAFE_INTEGER;
  for (const key of Object.keys(slideSpeakers)) {
    const slide = Number.parseInt(key, 10);
    if (!Number.isFinite(slide)) {
      continue;
    }

    const value = String(slideSpeakers[key] || "");
    if (slide < firstSlide) {
      firstSlide = slide;
      if (!speakerRef) {
        speakerRef = value;
      }
    }

    if (slide <= slideIndex && slide > bestSlide) {
      bestSlide = slide;
      speakerRef = value;
    }
  }

  if (!speakerRef || !Array.isArray(speakers)) {
    return null;
  }

  return speakers.find(speaker => matchesSpeaker(speaker, speakerRef)) || null;
}

function updateView(): void {
  const inControl = canControlSlides();
  elements.timerSection.hidden = !connection;
  elements.startRemoteButton.disabled = !isMainPresenter || !connection;
  elements.presentationName.textContent = timerStatus?.presentationName || getPresentationValue("title") || getPresentationValue("Title") || "Shared timer";
  elements.timerState.textContent = isSessionWaiting ? "Sharing is not started yet" : (timerStatus?.timerState || "Waiting");
  elements.controlBadge.textContent = inControl ? "In control" : isMainPresenter ? "Main presenter" : isTrustedSpeaker ? "Co-presenter" : "Viewing";
  elements.controlBadge.classList.toggle("control", inControl);

  if (!connection) {
    elements.slideStatus.textContent = "Slide sync is waiting for a shared timer.";
  } else if (isSessionWaiting) {
    elements.slideStatus.textContent = "Sharing is not started yet.";
  } else if (!isTrustedSpeaker) {
    elements.slideStatus.textContent = "Viewing only.";
  } else if (inControl) {
    elements.slideStatus.textContent = "Slide sync is on.";
  } else {
    elements.slideStatus.textContent = "Slide sync is waiting for speaker control.";
  }

}

function parseShareTarget(value: string): { code: string; origin: string } {
  const trimmed = value.trim();
  if (!trimmed) {
    return { code: "", origin: "" };
  }

  try {
    const url = new URL(trimmed);
    return {
      code: normalizeCode(url.searchParams.get("code") || url.pathname.split("/").filter(Boolean).pop() || ""),
      origin: url.origin
    };
  } catch {
    return { code: normalizeCode(trimmed), origin: "" };
  }
}

function normalizeCode(value: string): string {
  return value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
}

function maskCode(value: string): string {
  const code = normalizeCode(value);
  return code.length <= 2 ? code : `${code.slice(0, 2)}****`;
}

function addDiagnostic(message: string): void {
  console.debug(`[Timerinator add-in] ${message}`);
}

function normalizeKeys<T>(value: T): T {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return value;
  }

  const result: any = {};
  for (const [key, item] of Object.entries(value as any)) {
    const normalized = key.length ? key[0].toLowerCase() + key.slice(1) : key;
    result[normalized] = item;
  }

  return result;
}

function getPresentationValue(name: string): any {
  if (!presentation) {
    return null;
  }

  return presentation[name] ?? presentation[name[0].toUpperCase() + name.slice(1)];
}

function readEmbeddedPresentationValue(name: string): any {
  if (!embeddedPresentation) {
    return null;
  }

  return embeddedPresentation[name] ?? embeddedPresentation[name[0].toLowerCase() + name.slice(1)];
}

function getSpeakerValue(speaker: Nullable<SharedSpeaker>, name: "id" | "name" | "initials" | "colorHex" | "avatarDataUrl"): string {
  if (!speaker) {
    return "";
  }

  const key = name[0].toUpperCase() + name.slice(1) as "Id" | "Name" | "Initials" | "ColorHex" | "AvatarDataUrl";
  return String((speaker as any)[name] || (speaker as any)[key] || "");
}

function speakerDisplayName(speaker: Nullable<SharedSpeaker>): string {
  return getSpeakerValue(speaker, "initials") || getSpeakerValue(speaker, "name") || "Speaker";
}

function speakerDisplayNameForPicker(speaker: Nullable<SharedSpeaker>): string {
  const name = getSpeakerValue(speaker, "name");
  const initials = getSpeakerValue(speaker, "initials");
  if (name && initials) {
    return `${name} (${initials})`;
  }

  return name || initials || "Speaker";
}

function speakerKey(value: Nullable<string>): string {
  return String(value || "").trim().toLowerCase();
}

function isHostSpeakerReference(value: Nullable<string>): boolean {
  return speakerKey(value) === "host";
}

function matchesSpeaker(speaker: SharedSpeaker, value: string): boolean {
  const key = speakerKey(value);
  return !!key &&
    (speakerKey(getSpeakerValue(speaker, "id")) === key ||
      speakerKey(getSpeakerValue(speaker, "name")) === key ||
      speakerKey(getSpeakerValue(speaker, "initials")) === key);
}

function speakersMatch(left: SharedSpeaker, right: SharedSpeaker): boolean {
  return matchesSpeaker(left, getSpeakerValue(right, "id")) ||
    matchesSpeaker(left, getSpeakerValue(right, "name")) ||
    matchesSpeaker(left, getSpeakerValue(right, "initials"));
}

function isMe(speaker: Nullable<SharedSpeaker>): boolean {
  if (!speaker || !trustedSpeaker) {
    return false;
  }

  return matchesSpeaker(speaker, getSpeakerValue(trustedSpeaker, "id")) ||
    matchesSpeaker(speaker, getSpeakerValue(trustedSpeaker, "name")) ||
    matchesSpeaker(speaker, getSpeakerValue(trustedSpeaker, "initials"));
}

function toPositiveNumber(value: any): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.trunc(parsed) : 0;
}

function getFileNameFromUrl(value: string): string {
  if (!value) {
    return "";
  }

  try {
    const url = new URL(value);
    return decodeURIComponent(url.pathname.split("/").filter(Boolean).pop() || "");
  } catch {
    return value.split(/[\\/]/).filter(Boolean).pop() || "";
  }
}
